import { Store } from 'pullstate'

export enum PaymentsPermission {
  // Payments
  // manage payments profile_permissions
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_VIEW = 'can_manage_payments_profile_permissions_view',
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_ADD = 'can_manage_payments_profile_permissions_add',
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_EDIT = 'can_manage_payments_profile_permissions_edit',
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_DELETE = 'can_manage_payments_profile_permissions_delete',

  //Payments imports
  CAN_IMPORT_RECEIPTS = 'can_import_receipts_view',
  CAN_IMPORT_CREDITS = 'can_import_credits_view',

  // Fee Counter
  CAN_FEE_COUNTER_ACADEMIC_FEE = 'can_fee_counter_academic_fee',
  CAN_FEE_COUNTER_EXAM_FEE = 'can_fee_counter_exam_fee',
  // Fee Groups
  CAN_FEE_GROUP_VIEW = 'can_fee_groups_view',
  CAN_FEE_GROUP_ADD = 'can_fee_groups_add',
  CAN_FEE_GROUP_EDIT = 'can_fee_groups_edit',
  CAN_FEE_GROUP_DELETE = 'can_fee_groups_delete',

  // Fee Types
  CAN_FEE_TYPES_VIEW = 'can_fee_types_view',
  CAN_FEE_TYPES_ADD = 'can_fee_types_add',
  CAN_FEE_TYPES_EDIT = 'can_fee_types_edit',
  CAN_FEE_TYPES_DELETE = 'can_fee_types_delete',

  // Fee Structure
  CAN_FEE_STRUCTURE_VIEW = 'can_fee_structure_view',
  CAN_FEE_STRUCTURE_ADD = 'can_fee_structure_add',
  CAN_FEE_STRUCTURE_EDIT = 'can_fee_structure_edit',
  CAN_FEE_STRUCTURE_DELETE = 'can_fee_structure_delete',

  // Fine Configuration
  CAN_FINE_CONFIGURATION_VIEW = 'can_fine_configuration_view',
  CAN_FINE_CONFIGURATION_ADD = 'can_fine_configuration_add',
  CAN_FINE_CONFIGURATION_EDIT = 'can_fine_configuration_edit',
  CAN_FINE_CONFIGURATION_DELETE = 'can_fine_configuration_delete',

  // Student Permission
  CAN_STUDENT_PERMISSIONS_VIEW = 'can_student_permissions_view',
  CAN_STUDENT_PERMISSIONS_ADD = 'can_student_permissions_add',
  CAN_STUDENT_PERMISSIONS_EDIT = 'can_student_permissions_edit',
  CAN_STUDENT_PERMISSIONS_DELETE = 'can_student_permissions_delete',

  // Concession
  CAN_CONCESSION_VIEW = 'can_concession_view',
  CAN_CONCESSION_CHANGE_STATUS_ = 'can_concession_change_status',

  // Transactions delete
  CAN_TRANSACTIONS_DELETE = 'can_transaction_delete',
  // dashboard
  CAN_PAYMENTS_DASHBOARD_VIEW = 'can_dashboard_view',

  // student fee card
  CAN_STUDENT_FEE_CARD_VIEW = 'can_student_fee_card_view',

  // transaction fee card
  CAN_TRANSACTION_FEE_CARD = 'can_transcation_card_view',

  // Transfer Admissions
  CAN_TRANSFER_ADMISSION = 'can_transfer_admissions',

  // Transactions
  CAN_REPORT_VIEW = 'can_reports_view',
  CAN_FEES_IMPORT = 'can_fees_import',
  CAN_RESTORE_FEE_TRANSACTIONS = 'can_restore_fee_transactions',
  // Settings
  CAN_MANAGE_PAYMENTS_SETTINGS = 'can_payments_manage_settings',
}
export enum HostelsPermission {
  //Hostels

  // manage hostels profile_permissions
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_VIEW = 'manage_hostels_profile_permissions_view',
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_ADD = 'can_manage_hostels_profile_permissions_add',
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_EDIT = 'can_manage_hostels_profile_permissions_edit',
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_DELETE = 'can_manage_hostels_profile_permissions_delete',

  // Hosteler
  CAN_HOSTELER_DASHBOARD_VIEW = 'can_hosteler_dashboard_view',
  CAN_HOSTELER_VIEW = 'can_hosteler_view',
  CAN_HOSTELER_ADD = 'can_hosteler_add',
  CAN_HOSTELER_EDIT = 'can_hosteler_edit',
  CAN_HOSTELER_CHANGE_STATUS = 'can_hosteler_change_status',
  CAN_HOSTELER_FACE_DATA_RESET = 'can_hosteler_face_data_reset',
  CAN_HOSTELER_FEE_PAYMENT_VIEW = 'can_hosteler_fee_payments_view',
  CAN_HOSTELER_REPORTS_VIEW = 'can_hosteler_reports_view',

  // Hosteler Settings
  CAN_HOSTEL_DASHBOARD_VIEW = 'can_hostel_dashboard_view',
  CAN_HOSTEL_REPORTS_VIEW = 'can_hostel_reports_view',
  CAN_HOSTEL_FEE_PAYMENTS_VIEW = 'can_hostel_fee_payments_view',

  // Hostel Fee types
  CAN_HOSTEL_FEE_TYPES_ADD = 'can_hostel_fee_types_add',
  CAN_HOSTEL_FEE_TYPES_VIEW = 'can_hostel_fee_types_view',
  CAN_HOSTEL_FEE_TYPES_EDIT = 'can_hostel_fee_types_edit',
  CAN_HOSTEL_FEE_TYPES_DELETE = 'can_hostel_fee_types_delete',

  // Hostel Blocks
  CAN_HOSTEL_BLOCK_VIEW = 'can_hostel_blocks_view',
  CAN_HOSTEL_BLOCK_ADD = 'can_hostel_blocks_add',
  CAN_HOSTEL_BLOCK_EDIT = 'can_hostel_blocks_edit',
  CAN_HOSTEL_BLOCK_DELETE = 'can_hostel_blocks_delete',

  // Hostel Rooms
  CAN_HOSTEL_ROOMS_VIEW = 'can_hostel_rooms_view',
  CAN_HOSTEL_ROOMS_ADD = 'can_hostel_rooms_add',
  CAN_HOSTEL_ROOMS_EDIT = 'can_hostel_rooms_edit',
  CAN_HOSTEL_ROOMS_DELETE = 'can_hostel_rooms_delete',
  CAN_HOSTEL_ROOMS_IMPORT = 'can_hostel_rooms_import',

  // Hostel Amenitites
  CAN_HOSTEL_AMENITIES_VIEW = 'can_hostel_amenities_view',
  CAN_HOSTEL_AMENITIES_ADD = 'can_hostel_amenities_add',
  CAN_HOSTEL_AMENITIES_EDIT = 'can_hostel_amenities_edit',
  CAN_HOSTEL_AMENITIES_DELETE = 'can_hostel_amenities_delete',

  // Hostel Ticketing Group
  CAN_HOSTEL_TICKET_GROUP_VIEW = 'can_hostel_ticket_groups_view',
  CAN_HOSTEL_TICKET_GROUP_ADD = 'can_hostel_ticket_groups_add',
  CAN_HOSTEL_TICKET_GROUP_EDIT = 'can_hostel_ticket_groups_edit',
  CAN_HOSTEL_TICKET_GROUP_DELETE = 'can_hostel_ticket_groups_delete',

  CAN_HOSTEL_TICKET_GROUP_SERVICE_VIEW = 'can_hostel_ticket_group_service_view',
  CAN_HOSTEL_TICKET_GROUP_SERVICE_EDIT = 'can_hostel_ticket_group_service_edit',
  CAN_HOSTEL_TICKET_GROUP_SERVICE_DELETE = 'can_hostel_ticket_group_service_delete',
  CAN_HOSTEL_TICKET_GROUP_SERVICE_ADD = 'can_hostel_ticket_group_service_add',

  CAN_HOSTEL_TICKET_GROUP_USERS_VIEW = 'can_hostel_ticket_group_users_view',
  CAN_HOSTEL_TICKET_GROUP_USERS_DELETE = 'can_hostel_ticket_group_users_delete',
  CAN_HOSTEL_TICKET_GROUP_USERS_ADD = 'can_hostel_ticket_group_users_add',

  // Hostel Tickets
  CAN_HOSTEL_TICKETS_VIEW = 'can_hostel_tickets_view',
  CAN_HOSTEL_TICKETS_EDIT = 'can_hostel_tickets_edit',
  CAN_HOSTEL_TICKETS_DELETE = 'can_hostel_tickets_delete',
  CAN_HOSTEL_TICKETS_ADD = 'can_hostel_tickets_add',
}

export enum SquarePermissions {
  // Square
  // manage

  // manage square profile_permissions
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_VIEW = 'can_manage_square_profile_permissions_view',
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_ADD = 'can_manage_square_profile_permissions_add',
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_EDIT = 'can_manage_square_profile_permissions_edit',
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_DELETE = 'can_manage_square_profile_permissions_delete',

  // Org settings
  MANAGE_ROLES_AND_PROFILES = 'can_manage_roles_and_profiles',
  VIEW_AUDIT_LOGS = 'can_view_audit_logs',
  CAN_MANAGE_SETTINGS = 'can_manage_settings',
  CAN_MANAGE_ORG_SETTINGS = 'can_manage_org_settings',

  // Users
  USERS_VIEW = 'can_users_view',
  USERS_ADD = 'can_users_add',
  USERS_EDIT = 'can_users_edit',
  USERS_DELETE = 'can_users_delete',
  USERS_REORDER = 'can_users_reorder',
  USERS_UPLOAD_PHOTOS = 'can_user_upload_photos',
  USERS_EXPORT = 'can_users_export',

  // Students
  STUDENTS_VIEW = 'can_students_view',
  STUDENTS_ADD = 'can_students_add',
  STUDENTS_EDIT = 'can_students_edit',
  STUDENTS_DELETE = 'can_students_delete',
  STUDENTS_DETAIN = 'can_students_detain',
  STUDENTS_IMPORT = 'can_students_import',
  STUDENTS_EXPORT = 'can_students_export',
  STUDENTS_RESULTS = 'can_students_results',
  STUDENTS_UPLOAD_PHOTOS = 'can_students_upload_photos',
  STUDENTS_TRANSFER = 'can_students_transfer',
  STUDENTS_ALLOTMENT = 'can_students_allotment',

  // Subjects
  SUBJECTS_VIEW = 'can_subjects_view',
  SUBJECTS_ADD = 'can_subjects_add',
  SUBJECTS_EDIT = 'can_subjects_edit',
  SUBJECTS_DELETE = 'can_subjects_delete',
  SUBJECTS_EDIT_SUBJECT_INFO = 'can_subjects_edit_subject_info',
  SUBJECTS_BATCH_CONFIG_VIEW = 'can_subjects_batch_config_view',
  SUBJECTS_BATCH_CONFIG_EDIT = 'can_subjects_batch_config_edit',

  // Course Registartions
  COURSE_REGISTRATION_VIEW = 'can_course_registration_view',
  COURSE_REGISTRATION_ADD = 'can_course_registration_add',
  COURSE_REGISTRATION_EDIT = 'can_course_registration_edit',
  COURSE_REGISTRATION_DELETE = 'can_course_registration_delete',

  // Mentors
  CAN_VIEW_MENTORS = 'can_view_mentors',
  CAN_ADD_MENTORS = 'can_add_mentors',
  CAN_ASSIGN_MENTEES = 'can_assign_mentees',
  CAN_REMOVE_MENTEES = 'can_remove_mentees',
  CAN_VIEW_MENTOR_REPORT = 'can_view_mentor_report',
  CAN_COMMENT_ON_MENTOR_REPORT = 'can_comment_on_mentor_report',
  CAN_VIEW_MENTEES = 'can_view_mentees',
  CAN_CREATE_SESSION = 'can_create_session',
  CAN_VIEW_MENTEE_REPORT = 'can_view_mentee_report',
  CAN_VIEW_MENTOR_SESSIONS = 'can_view_mentor_sessions',
  CAN_VIEW_MENTOR_SESSIONS_COMMENTS = 'can_view_mentor_sessions_comments',
  CAN_ADD_MENTOR_SESSIONS_COMMENTS = 'can_add_mentor_sessions_comments',
  CAN_EDIT_MENTOR_SESSIONS_COMMENTS = 'can_edit_mentor_sessions_comments',
  CAN_DELETE_MENTOR_SESSIONS_COMMENTS = 'can_delete_mentor_sessions_comments',

  // Extra Cirricular activities
  EXTRA_CURRICULAR_ACTIVITIES_NEWS_FEED = 'can_extra_curricular_activities_news_feed',
  EXTRA_CURRICULAR_ACTIVITIES_CLUBS = 'can_extra_curricular_activities_clubs',
  EXTRA_CURRICULAR_ACTIVITIES_EVENTS = 'can_extra_curricular_activities_events',

  //Classroom

  CLASSROOM_VIEW = 'can_classroom_view',
  CLASSROOM_EDIT = 'can_classroom_edit',
  CLASSROOM_DELETE = 'can_classroom_delete',
  CLASSROOM_ADD = 'can_classroom_add',
  CLASSROOM_REPORTS = 'can_classroom_reports',
  CAN_VIEW_FEE_DUE_REPORT = 'can_view_fee_due_report',
  CLASSROOM_REASSIGN_FACULTY = 'can_classroom_re_assign_faculty',
  CAN_REVOKE_MARKS = 'can_classroom_revoke_marks',
  CAN_CLASSROOM_SUBJECTS_VIEW = 'can_classroom_subjects_view',
  CAN_CLASSROOM_SUBJECT_ATTENDANCE_EDIT = 'can_classroom_subject_attendance_edit',

  //my subjects
  CAN_VIEW_MY_SUBJECTS = 'can_view_my_subjects',

  // Feed
  CAN_ADD_FEED = 'can_feed_add',

  // Degrees
  CAN_DEGRESS_ADD = 'can_degrees_add',
  CAN_DEGRESS_DELETE = 'can_degrees_delete',
  CAN_DEGRESS_EDIT = 'can_degrees_edit',
  CAN_DEGRESS_VIEW = 'can_degrees_view',

  // Programs
  CAN_PROGRAMS_ADD = 'can_programs_add',
  CAN_PROGRAMS_DELETE = 'can_programs_delete',
  CAN_PROGRAMS_EDIT = 'can_programs_edit',
  CAN_PROGRAMS_VIEW = 'can_programs_view',

  // Semesters
  CAN_SEMESTERS_ADD = 'can_semesters_add',
  CAN_SEMESTERS_DELETE = 'can_semesters_delete',
  CAN_SEMESTERS_EDIT = 'can_semesters_edit',
  CAN_SEMESTERS_VIEW = 'can_semesters_view',

  // Curriculums
  CAN_CURRICULUMS_ADD = 'can_curriculums_add',
  CAN_CURRICULUMS_EDIT = 'can_curriculums_edit',
  CAN_CURRICULUMS_DELETE = 'can_curriculums_delete',
  CAN_CURRICULUMS_VIEW = 'can_curriculums_view',

  // Subject types
  SUBJECT_TYPE_VIEW = 'can_subject_types_view',
  SUBJECT_TYPE_ADD = 'can_subject_types_add',
  SUBJECT_TYPE_EDIT = 'can_subject_types_edit',
  SUBJECT_TYPE_DELETE = 'can_subject_types_delete',

  // Assessment Type
  ASSESSMENT_TYPE_VIEW = 'can_assessment_types_view',
  ASSESSMENT_TYPE_ADD = 'can_assessment_types_add',
  ASSESSMENT_TYPE_EDIT = 'can_assessment_types_edit',
  ASSESSMENT_TYPE_DELETE = 'can_assessment_types_delete',

  // Assessment Templates
  CAN_ASSESSMENT_TEMPLATES_ADD = 'can_assessment_templates_add',
  CAN_ASSESSMENT_TEMPLATES_EDIT = 'can_assessment_templates_edit',
  CAN_ASSESSMENT_TEMPLATES_VIEW = 'can_assessment_templates_view',
  CAN_ASSESSMENT_TEMPLATES_DELETE = 'can_assessment_templates_delete',

  // Assessment Rules
  CAN_ASSESSMENT_RULES_ADD = 'can_assessment_rules_add',
  CAN_ASSESSMENT_RULES_DELETE = 'can_assessment_rules_delete',
  CAN_ASSESSMENT_RULES_EDIT = 'can_assessment_rules_edit',
  CAN_ASSESSMENT_RULES_VIEW = 'can_assessment_rules_view',

  // Schools
  SCHOOLS_VIEW = 'can_schools_view',
  SCHOOLS_ADD = 'can_schools_add',
  SCHOOLS_EDIT = 'can_schools_edit',
  SCHOOLS_DELETE = 'can_schools_delete',

  // Master Subjects
  CAN_MASTER_SUBJECT_VIEW = 'can_master_subject_view',
  CAN_MASTER_SUBJECT_ADD = 'can_master_subject_add',
  CAN_MASTER_SUBJECT_EDIT = 'can_master_subject_edit',
  CAN_MASTER_SUBJECT_DELETE = 'can_master_subject_delete',

  // Tasks
  CAN_TASKS_ADD = 'can_tasks_add',
  CAN_TASKS_DELETE = 'can_tasks_delete',
  CAN_TASKS_EDIT = 'can_tasks_edit',
  CAN_TASKS_VIEW = 'can_tasks_view',
  CAN_TASKS_CHANGE_STATUS = 'can_tasks_change_status',

  // Academic Calendar
  ACADEMIC_CALENDAR_VIEW = 'can_academic_calendar_view',
  ACADEMIC_CALENDAR_EVENT_ADD = 'can_academic_calendar_event_add',
  ACADEMIC_CALENDAR_EVENT_EDIT = 'can_academic_calendar_event_edit',
  ACADEMIC_CALENDAR_EVENT_DELETE = 'can_academic_calendar_event_delete',
  // Academic calendar timeline
  CAN_ACADEMIC_CALENDAR_TIMELINE_VIEW = 'can_academic_calendar_timeline_view',
  // Time Slots
  CAN_TIME_SLOTS_VIEW = 'can_time_slots_view',
  CAN_TIME_SLOTS_ADD = 'can_time_slots_add',
  CAN_TIME_SLOTS_EDIT = 'can_time_slots_edit',
  CAN_TIME_SLOTS_DELETE = 'can_time_slots_delete',

  //Departments
  CAN_DEPARTMENTS_VIEW = 'can_departments_view',
  CAN_DEPARTMENTS_ADD = 'can_departments_add',
  CAN_DEPARTMENTS_EDIT = 'can_departments_edit',
  CAN_DEPARTMENTS_DELETE = 'can_departments_delete',

  //Designations
  DESIGNATIONS_ADD = 'can_designations_add',
  DESIGNATIONS_DELETE = 'can_designations_delete',
  DESIGNATIONS_EDIT = 'can_designations_edit',
  DESIGNATIONS_VIEW = 'can_designations_view',

  // Form Builder
  CAN_FORM_BUILDER_VIEW = 'can_form_builder_view',
  CAN_FORM_BUILDER_EDIT = 'can_form_builder_edit',
  CAN_FORM_BUILDER_ADD = 'can_form_builder_add',
  CAN_FORM_BUILDER_DELETE = 'can_form_builder_delete',

  // Surveys
  CAN_SURVEYS_VIEW = 'can_surveys_view',
  CAN_SURVEYS_EDIT = 'can_surveys_edit',
  CAN_SURVEYS_ADD = 'can_surveys_add',
  CAN_SURVEYS_DELETE = 'can_surveys_delete',
}

export enum EnrollPermissions {
  // Enroll X

  // manage exams profile_permissions
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_VIEW = 'can_manage_enroll_x_profile_permissions_view',
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_ADD = 'can_manage_enroll_x_profile_permissions_add',
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_EDIT = 'can_manage_enroll_x_profile_permissions_edit',
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_DELETE = 'can_manage_enroll_x_profile_permissions_delete',

  // Leads
  CAN_LEADS_VIEW = 'can_leads_view',
  CAN_LEADS_ADD = 'can_leads_add',
  CAN_LEADS_EDIT = 'can_leads_edit',
  CAN_LEADS_DELETE = 'can_leads_delete',
  CAN_LEADS_IMPORT = 'can_leads_import',
  CAN_ASSIGN_COUNSELLOR_LEADS = 'can_leads_assign_counsellor',
  CAN_LEADS_CONVERT_TO_ADMISSION = 'can_leads_convert_to_admission',

  // Clusters
  CAN_CLUSTERS_VIEW = 'can_clusters_view',
  CAN_CLUSTERS_EDIT = 'can_clusters_edit',
  CAN_CLUSTERS_ADD = 'can_clusters_add',
  CAN_CLUSTERS_DELETE = 'can_clusters_delete',
  CAN_CLUSTERS_DASHBOARD_VIEW = 'can_clusters_dashboard_view',

  // Counsellor
  CAN_COUNSELLOR_VIEW = 'can_counsellor_view',
  CAN_COUNSELLOR_ADD = 'can_counsellor_add',
  CAN_COUNSELLOR_DELETE = 'can_counsellor_delete',

  // Notifications
  CAN_NOTIFICATION_ADD = 'can_notification_add',
  CAN_NOTIFICATION_EDIT = 'can_notification_edit',
  CAN_NOTIFICATION_DELETE = 'can_notification_delete',
  CAN_NOTIFICATION_VIEW = 'can_notification_view',

  // Admissions
  ADMISSIONS_ADD = 'can_admissions_add',
  ADMISSIONS_VIEW = 'can_admissions_view',
  ADMISSIONS_EDIT = 'can_admissions_edit',
  ADMISSIONS_DELETE = 'can_admissions_delete',
  ADMISSIONS_CHANGE_STATUS = 'can_admissions_change_status',
  ADMISSIONS_CHANGE_QUOTA = 'can_admissions_change_quota',
  ADMISSIONS_IMPORT = 'can_admissions_import',
  ADMISSIONS_EXPORT = 'can_admissions_export',
  ADMISSIONS_CONFIRM = 'can_admissions_confirm',
  CAN_ADMISSION_REJECT = 'can_admissions_reject',
  CAN_ADMISSIONS_DASHBOARD_VIEW = 'can_admission_dashboard_view',
  CAN_ADMISSIONS_GRAPH_VIEW = 'can_admission_graph_view',
  CAN_ADMISSIONS_LEAD_REMARKS = 'can_admission_lead_remarks',
  CAN_ENROLL_X_AUDIT_LOGS = 'can_enroll_x_view_audit_logs',
  CAN_ADMISSION_APPROVAL = 'can_admission_approvals',
  // CET & PHD
  CAN_PHD_FORM_VIEW = 'can_admissions_view_phd_applications',
  CAN_PHD_FORM_DOWNLOAD = 'can_admissions_download_phd_applications',
  CAN_CET_VIEW = 'can_admissions_view_cet',
  CAN_EDIT_VIEW = 'can_admissions_edit_cet',
  CAN_CET_DOWNLOAD = 'can_admissions_download_cet',

  // Settings
  CAN_MANAGE_ENROLL_X_SETTINGS = 'can_enroll_x_manage_settings',

  // Quotas
  CAN_QUOTAS_EDIT = 'can_quotas_edit',
  CAN_QUOTAS_DELETE = 'can_quotas_delete',
  CAN_QUOTAS_ADD = 'can_quotas_add',
  CAN_QUOTAS_VIEW = 'can_quotas_view',

  // Lead Status
  CAN_LEAD_STATUS_VIEW = 'can_lead_status_view',
  CAN_LEAD_STATUS_EDIT = 'can_lead_status_edit',
  CAN_LEAD_STATUS_ADD = 'can_lead_status_add',
  CAN_LEAD_STATUS_DELETE = 'can_lead_status_delete',

  // Lead Sources
  CAN_LEAD_SOURCES_VIEW = 'can_lead_sources_view',
  CAN_LEAD_SOURCES_ADD = 'can_lead_sources_add',
  CAN_LEAD_SOURCES_EDIT = 'can_lead_sources_edit',
  CAN_LEAD_SOURCES_DELETE = 'can_lead_sources_delete',

  // Student Certificate
  CAN_STUDENT_CERTIFICATES_VIEW = 'can_student_certificates_view',
  CAN_STUDENT_CERTIFICATES_EDIT = 'can_student_certificates_edit',
  CAN_STUDENT_CERTIFICATES_DELETE = 'can_student_certificates_delete',
  CAN_STUDENT_CERTIFICATES_ADD = 'can_student_certificates_add',
}

export enum ExamsPermissions {
  // Exams

  // manage exams profile_permissions
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_VIEW = 'can_manage_exams_profile_permissions_view',
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_ADD = 'can_manage_exams_profile_permissions_add',
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_EDIT = 'can_manage_exams_profile_permissions_edit',
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_DELETE = 'can_manage_exams_profile_permissions_delete',

  // End Semester Examination
  CAN_END_SEMESTER_EXAMINATIONS_VIEW = 'can_end_semester_examinations_view',
  CAN_END_SEMESTER_EXAMINATIONS_ADD = 'can_end_semester_examinations_add',
  CAN_END_SEMESTER_EXAMINATIONS_EDIT = 'can_end_semester_examinations_edit',
  CAN_END_SEMESTER_EXAMINATIONS_DELETE = 'can_end_semester_examinations_delete',

  // Registrations
  CAN_EXAM_REGISTARTIONS_VIEW = 'can_exam_registrations_view',
  CAN_EXAM_REGISTARTIONS_ADD = 'can_exam_registrations_add',

  // Fee configuration
  EXAM_FEE_CONFIGURATION_VIEW = 'can_exam_fee_configuration_view',
  EXAM_FEE_CONFIGURATION_ADD = 'can_exam_fee_configuration_add',

  // Time table
  CAN_EXAM_TIMETABLE_VIEW = 'can_exam_timetable_view',
  CAN_EXAM_TIMETABLE_ADD = 'can_exam_timetable_add',
  CAN_EXAM_TIMETABLE_EDIT = 'can_exam_timetable_edit',
  CAN_EXAM_TIMETABLE_DELETE = 'can_exam_timetable_delete',

  // Hall tickets
  CAN_HALL_TICKETS_VIEW = 'can_hall_tickets_view',

  // OMRS
  CAN_OMRS_VIEW = 'can_omrs_view',
  CAN_OMRS_UPDATE = 'can_omrs_update',
  CAN_OMRS_GENERATE = 'can_omrs_generate',

  // Paper Configuration
  CAN_PAPER_CONFIGURATION_VIEW = 'can_paper_configuration_view',
  CAN_PAPER_CONFIGURATION_ADD = 'can_paper_configuration_add',
  CAN_PAPER_CONFIGURATION_EDIT = 'can_paper_configuration_edit',
  CAN_PAPER_CONFIGURATION_DELETE = 'can_paper_configuration_delete',

  // D Form
  CAN_D_FORM_VIEW = 'can_d_forms_view',
  CAN_D_FORM_ADD = 'can_d_forms_add',

  // Bundling
  CAN_VIEW_ANSWER_SHEET_REPORT = 'can_view_answer_sheet_report',
  CAN_BUNDLING_VIEW = 'can_bundling_view',
  CAN_BUNDLING_ADD = 'can_bundling_add',
  CAN_BUNDLING_EDIT = 'can_bundling_edit',
  CAN_BUNDLING_DELETE = 'can_bundling_delete',
  CAN_BUNDLING_UPDATE_BUNDLE_STATUS = 'can_bundling_update_bundle_status',
  CAN_BUNDLING_BUNDLE_SHEETS_ADD = 'can_bundling_bundle_sheets_add',
  CAN_BUNDLING_BUNDLE_SHEETS_REMOVE = 'can_bundling_bundle_sheets_remove',

  // Internal Marks
  CAN_INTERNAL_MARKS_VIEW = 'can_internal_marks_view',
  CAN_INTERNAL_MARKS_ADD = 'can_internal_marks_add',
  CAN_INTERNAL_MARKS_EDIT = 'can_internal_marks_edit',
  CAN_INTERNAL_MARKS_IMPORT = 'can_internal_marks_import',
  CAN_INTERANL_MARKS_IMPORT_LMS = 'can_internal_marks_import_lms',

  // External Marks
  CAN_EXTERNAL_MARKS_VIEW = 'can_external_marks_view',
  CAN_EXTERNAL_MARKS_ADD = 'can_external_marks_add',
  CAN_EXTERNAL_MARKS_EDIT = 'can_external_marks_edit',

  // Result Processing
  CAN_RESULTS_PROCESSING_VIEW = 'can_results_processing_view_reports',
  CAN_RESULTS_PROCESSING_GENERATE_MEMOS = 'can_results_processing_generate_memos',
  CAN_RESULTS_PROCESSING_MODERATION_AND_GRAFTING = 'can_results_processing_moderation_and_grafting',
  CAN_RESULTS_PROCESSING_PUBLISH_RESULTS = 'can_results_processing_publish_results',
  CAN_RESULTS_PROCESSING_UPDATE_INTERNAL_MARKS = 'can_results_processing_update_internal_marks',

  // Revaluation Fee Configuration
  CAN_REVALUATION_FEE_CONFIGURATION_VIEW = 'can_revaluation_fee_configuration_view',
  CAN_REVAULATION_FEE_CONFIGURATION_ADD = 'can_revaluation_fee_configuration_add',

  //Revaluation
  CAN_REVALUATION_VIEW = 'can_revaluation_view',
  CAN_REVALUATION_REGISTRATIONS_ADD = 'can_revaluation_add_registrations',
  CAN_REVALUATION_OMRS = 'can_revaluation_omrs',
  CAN_REVALUATION_ADD_MARKS = 'can_revaluation_add_marks',
  CAN_REVALUATION_EDIT_MARKS = 'can_revaluation_edit_marks',
  CAN_REVALUATION_PROCESS_REVAL = 'can_revaluation_process_reval',
  CAN_REVALUATION_VIEW_REPORTS = 'can_revaluation_view_reports',
  CAN_REVALUATION_GENERATE_MEMOS = 'can_revaluation_generate_memos',

  // Internal Examinations
  CAN_INTERNAL_EXAMINATIONS_VIEW = 'can_internal_examinations_view',
  CAN_INTERNAL_EXAMINATIONS_ADD = 'can_internal_examinations_add',
  CAN_INTERNAL_EXAMINATIONS_EDIT = 'can_internal_examinations_edit',
  CAN_INTERNAL_EXAMINATIONS_DELETE = 'can_internal_examinations_delete',
  CAN_INTERNAL_EXAMINATIONS_MANAGE_EXAM_FEE = 'can_internal_examinations_manage_exam_fee',

  // Seating Plan
  SEATING_PLAN = 'can_examinations_seating_plan',
  CAN_SEATING_PLAN_VIEW = 'can_seating_plan_view',
  CAN_SEATING_PLAN_ADD = 'can_seating_plan_add',
  CAN_SEATING_PLAN_DELETE = 'can_seating_plan_delete',

  // Invigilations
  CAN_INVIGILATIONS_VIEW = 'can_invigilations_view',
  CAN_INVIGILATIONS_ADD = 'can_invigilations_add',

  // Settings
  CAN_MANAGE_EXAMS_SETTINGS = 'can_exams_manage_settings',
  // Evaluators
  CAN_EVALUATORS_VIEW = 'can_evaluators_view',
  CAN_EVALUATORS_ADD = 'can_evaluators_add',
  CAN_EVALUATORS_EDIT = 'can_evaluators_edit',
  CAN_EVALUATORS_DELETE = 'can_evaluators_delete',

  // Grades
  CAN_GRADES_ADD = 'can_grades_add',
  CAN_GRADES_EDIT = 'can_grades_edit',
  CAN_GRADES_DELETE = 'can_grades_delete',
  CAN_GRADES_VIEW = 'can_grades_view',

  // Rooms
  CAN_EXAM_ROOM_VIEW = 'can_exam_rooms_view',
  CAN_EXAM_ROOM_ADD = 'can_exam_rooms_add',
  CAN_EXAM_ROOM_EDIT = 'can_exam_rooms_edit',
  CAN_EXAM_ROOM_DELETE = 'can_exam_rooms_delete',

  // Marks Division
  CAN_MARKS_DIVISION_VIEW = 'can_marks_division_view',
  CAN_MARKS_DIVISION_ADD = 'can_marks_division_add',
  CAN_MARKS_DIVISION_EDIT = 'can_marks_division_edit',
  CAN_MARKS_DIVISION_DELETE = 'can_marks_division_delete',

  //  Time slots
  CAN_EXAM_TIME_SLOTS_VIEW = 'can_exam_time_slots_view',
  CAN_EXAM_TIME_SLOTS_ADD = 'can_exam_time_slots_add',
  CAN_EXAM_TIME_SLOTS_EDIT = 'can_exam_time_slots_edit',
  CAN_EXAM_TIME_SLOTS_DELETE = 'can_exam_time_slots_delete',
}

export enum Permission {
  // General
  CAN_INDIVIDUAL_PAGES_VIEW = 'can_individual_pages_view',
  CAN_SETTINGS_VIEW = 'can_settings_view',
  CAN_DASHBOARD_VIEW = 'can_dashboard_view',
  CAN_ANALYTICS_VIEW = 'can_analytics_view',

  // Payments
  // manage payments profile_permissions
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_VIEW = 'can_manage_payments_profile_permissions_view',
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_ADD = 'can_manage_payments_profile_permissions_add',
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_EDIT = 'can_manage_payments_profile_permissions_edit',
  CAN_MANAGE_PAYMENTS_PROFILE_PERMISSIONS_DELETE = 'can_manage_payments_profile_permissions_delete',

  // Fee Counter
  CAN_FEE_COUNTER_ACADEMIC_FEE = 'can_fee_counter_academic_fee',
  CAN_FEE_COUNTER_EXAM_FEE = 'can_fee_counter_exam_fee',

  //Payments imports
  CAN_IMPORT_RECEIPTS = 'can_import_receipts_view',
  CAN_IMPORT_CREDITS = 'can_import_credits_view',

  // Fee Groups
  CAN_FEE_GROUP_VIEW = 'can_fee_groups_view',
  CAN_FEE_GROUP_ADD = 'can_fee_groups_add',
  CAN_FEE_GROUP_EDIT = 'can_fee_groups_edit',
  CAN_FEE_GROUP_DELETE = 'can_fee_groups_delete',

  // Fee Types
  CAN_FEE_TYPES_VIEW = 'can_fee_types_view',
  CAN_FEE_TYPES_ADD = 'can_fee_types_add',
  CAN_FEE_TYPES_EDIT = 'can_fee_types_edit',
  CAN_FEE_TYPES_DELETE = 'can_fee_types_delete',

  // Fee Structure
  CAN_FEE_STRUCTURE_VIEW = 'can_fee_structure_view',
  CAN_FEE_STRUCTURE_ADD = 'can_fee_structure_add',
  CAN_FEE_STRUCTURE_EDIT = 'can_fee_structure_edit',
  CAN_FEE_STRUCTURE_DELETE = 'can_fee_structure_delete',

  // Fine Configurastion
  CAN_FINE_CONFIGURATION_VIEW = 'can_fine_configurations_view',
  CAN_FINE_CONFIGURATION_ADD = 'can_fine_configurations_add',
  CAN_FINE_CONFIGURATION_EDIT = 'can_fine_configurations_edit',
  CAN_FINE_CONFIGURATION_DELETE = 'can_fine_configurations_delete',

  // Student Permission
  CAN_STUDENT_PERMISSIONS_VIEW = 'can_student_permissions_view',
  CAN_STUDENT_PERMISSIONS_ADD = 'can_student_permissions_add',
  CAN_STUDENT_PERMISSIONS_EDIT = 'can_student_permissions_edit',
  CAN_STUDENT_PERMISSIONS_DELETE = 'can_student_permissions_delete',

  // Concession
  CAN_CONCESSION_VIEW = 'can_concession_view',
  CAN_CONCESSION_CHANGE_STATUS_ = 'can_concession_change_status',
  CAN_CONCESSION_EDIT = 'can_concession_edit',

  // dashboard
  CAN_PAYMENTS_DASHBOARD_VIEW = 'can_dashboard_view',

  // student fee card
  CAN_STUDENT_FEE_CARD_VIEW = 'can_student_fee_card_view',

  // transaction fee card
  CAN_TRANSACTION_FEE_CARD = 'can_transcation_card_view',

  // Transfer Admissions
  CAN_TRANSFER_ADMISSION = 'can_transfer_admissions',

  // Transactions delete
  CAN_TRANSACTIONS_DELETE = 'can_transaction_delete',
  // Transactions
  CAN_REPORT_VIEW = 'can_reports_view',
  CAN_FEES_IMPORT = 'can_fees_import',
  CAN_RESTORE_FEE_TRANSACTIONS = 'can_restore_fee_transactions',
  // Settings
  CAN_MANAGE_PAYMENTS_SETTINGS = 'can_payments_manage_settings',
  //Reports
  CAN_PAYMENT_REPORTS_VIEW = 'can_payment_reports_view',
  CAN_FEE_REPORT_VIEW = 'can_fee_report_view',
  CAN_FEE_DUE_LIST_VIEW = 'can_fee_due_list_view',
  CAN_ADVANCE_DUE_REPORT_VIEW = 'can_advance_due_report_view',
  CAN_FEE_BY_CLASS_VIEW = 'can_fee_by_class_view',
  CAN_BRANCH_WISE_REPORT_VIEW = 'can_branch_wise_report_view',
  CAN_DETAINED_STUDENT_VIEW = 'can_detained_student_view',
  CAN_DISCONTINUED_STUDENT_VIEW = 'can_discontinued_student_view',
  CAN_CONCESSION_REPORT_VIEW = 'can_concession_report_view',
  CAN_FEE_TYPE_SUMMARY_REPORT_VIEW = 'can_fee_type_summary_report_view',
  CAN_PROGRAM_WISE_FEE_TYPE_REPORT_VIEW = 'can_program_wise_fee_type_report_view',
  CAN_EXAMINATION_REPORT_VIEW = 'can_examination_report_view',
  CAN_EXAMINATION_NOT_PAID_REPORT_VIEW = 'can_examination_not_paid_report_view',
  CAN_EXAMINATION_BLOCKED_STUDENTS_VIEW = 'can_examination_blocked_students_view',
  //Activity logs
  CAN_PAYMENT_X_AUDIT_LOGS = 'can_payment_x_view_audit_logs',

  // Commute X
  // manage hostels profile_permissions
  CAN_MANAGE_COMMUTE_X_PROFILE_PERMISSIONS_VIEW = 'can_manage_commute_x_profile_permissions_view',
  CAN_MANAGE_COMMUTE_X_PROFILE_PERMISSIONS_ADD = 'can_manage_commute_x_profile_permissions_add',
  CAN_MANAGE_COMMUTE_X_PROFILE_PERMISSIONS_EDIT = 'can_manage_commute_x_profile_permissions_edit',
  CAN_MANAGE_COMMUTE_X_PROFILE_PERMISSIONS_DELETE = 'can_manage_commute_x_profile_permissions_delete',

  //registrations
  CAN_COMMUTE_X_REGISTRATIONS_VIEW = 'can_commute_x_registrations_view',
  CAN_COMMUTE_X_REGISTRATIONS_EDIT = 'can_commute_x_registrations_edit',
  CAN_COMMUTE_X_REGISTRATIONS_DELETE = 'can_commute_x_registrations_delete',
  CAN_COMMUTE_X_REGISTRATIONS_ADD = 'can_commute_x_registrations_add',

  //routes
  CAN_COMMUTE_X_ROUTES_VIEW = 'can_commute_x_routes_view',
  CAN_COMMUTE_X_ROUTES_EDIT = 'can_commute_x_routes_edit',
  CAN_COMMUTE_X_ROUTES_DELETE = 'can_commute_x_routes_delete',
  CAN_COMMUTE_X_ROUTES_ADD = 'can_commute_x_routes_add',

  //settings
  CAN_MANAGE_COMMUTE_X_SETTINGS = 'can_commute_x_manage_settings',

  //Hostels

  // manage hostels profile_permissions
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_VIEW = 'can_manage_hostels_profile_permissions_view',
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_ADD = 'can_manage_hostels_profile_permissions_add',
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_EDIT = 'can_manage_hostels_profile_permissions_edit',
  CAN_MANAGE_HOSTELS_PROFILE_PERMISSIONS_DELETE = 'can_manage_hostels_profile_permissions_delete',

  // Hosteler
  CAN_HOSTELER_DASHBOARD_VIEW = 'can_hosteler_dashboard_view',
  CAN_HOSTELER_VIEW = 'can_hosteler_view',
  CAN_HOSTELER_ADD = 'can_hosteler_add',
  CAN_HOSTELER_EDIT = 'can_hosteler_edit',
  CAN_HOSTELER_CHANGE_STATUS = 'can_hosteler_change_status',
  CAN_HOSTELER_FACE_DATA_RESET = 'can_hosteler_face_data_reset',
  CAN_HOSTELER_FEE_PAYMENT_VIEW = 'can_hosteler_fee_payments_view',
  CAN_HOSTELER_REPORTS_VIEW = 'can_hosteler_reports_view',

  // Hosteler Settings
  CAN_HOSTEL_DASHBOARD_VIEW = 'can_hostel_dashboard_view',
  CAN_HOSTEL_REPORTS_VIEW = 'can_hostel_reports_view',
  CAN_HOSTEL_FEE_PAYMENTS_VIEW = 'can_hostel_fee_payments_view',

  // Hostel Fee types
  CAN_HOSTEL_FEE_TYPES_ADD = 'can_hostel_fee_types_add',
  CAN_HOSTEL_FEE_TYPES_VIEW = 'can_hostel_fee_types_view',
  CAN_HOSTEL_FEE_TYPES_EDIT = 'can_hostel_fee_types_edit',
  CAN_HOSTEL_FEE_TYPES_DELETE = 'can_hostel_fee_types_delete',

  // Hostel Blocks
  CAN_HOSTEL_BLOCK_VIEW = 'can_hostel_blocks_view',
  CAN_HOSTEL_BLOCK_ADD = 'can_hostel_blocks_add',
  CAN_HOSTEL_BLOCK_EDIT = 'can_hostel_blocks_edit',
  CAN_HOSTEL_BLOCK_DELETE = 'can_hostel_blocks_delete',

  // Hostel Rooms
  CAN_HOSTEL_ROOMS_VIEW = 'can_hostel_rooms_view',
  CAN_HOSTEL_ROOMS_ADD = 'can_hostel_rooms_add',
  CAN_HOSTEL_ROOMS_EDIT = 'can_hostel_rooms_edit',
  CAN_HOSTEL_ROOMS_DELETE = 'can_hostel_rooms_delete',
  CAN_HOSTEL_ROOMS_IMPORT = 'can_hostel_rooms_import',

  // Hostel Ameneitites
  CAN_HOSTEL_AMENITIES_VIEW = 'can_hostel_amenities_view',
  CAN_HOSTEL_AMENITIES_ADD = 'can_hostel_amenities_add',
  CAN_HOSTEL_AMENITIES_EDIT = 'can_hostel_amenities_edit',
  CAN_HOSTEL_AMENITIES_DELETE = 'can_hostel_amenities_delete',

  // Hostel Ticketing Group
  CAN_HOSTEL_TICKET_GROUP_VIEW = 'can_hostel_ticket_groups_view',
  CAN_HOSTEL_TICKET_GROUP_ADD = 'can_hostel_ticket_groups_add',
  CAN_HOSTEL_TICKET_GROUP_EDIT = 'can_hostel_ticket_groups_edit',
  CAN_HOSTEL_TICKET_GROUP_DELETE = 'can_hostel_ticket_groups_delete',

  CAN_HOSTEL_TICKET_GROUP_SERVICE_VIEW = 'can_hostel_ticket_group_service_view',
  CAN_HOSTEL_TICKET_GROUP_SERVICE_EDIT = 'can_hostel_ticket_group_service_edit',
  CAN_HOSTEL_TICKET_GROUP_SERVICE_DELETE = 'can_hostel_ticket_group_service_delete',
  CAN_HOSTEL_TICKET_GROUP_SERVICE_ADD = 'can_hostel_ticket_group_service_add',

  CAN_HOSTEL_TICKET_GROUP_USERS_VIEW = 'can_hostel_ticket_group_users_view',
  CAN_HOSTEL_TICKET_GROUP_USERS_DELETE = 'can_hostel_ticket_group_users_delete',
  CAN_HOSTEL_TICKET_GROUP_USERS_ADD = 'can_hostel_ticket_group_users_add',

  // Hostel Tickets
  CAN_HOSTEL_TICKETS_VIEW = 'can_hostel_tickets_view',
  CAN_HOSTEL_TICKETS_EDIT = 'can_hostel_tickets_edit',
  CAN_HOSTEL_TICKETS_DELETE = 'can_hostel_tickets_delete',
  CAN_HOSTEL_TICKETS_ADD = 'can_hostel_tickets_add',

  // Hosteler attendance
  CAN_HOSTELER_ATTENDANCE_VIEW = 'can_hosteler_attendance_view',
  CAN_HOSTELER_ATTENDANCE_EDIT = 'can_hosteler_attendance_edit',
  CAN_HOSTELER_ATTENDANCE_ADD = 'can_hosteler_attendance_add',

  // Square
  // manage

  // manage square profile_permissions
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_VIEW = 'can_manage_square_profile_permissions_view',
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_ADD = 'can_manage_square_profile_permissions_add',
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_EDIT = 'can_manage_square_profile_permissions_edit',
  CAN_MANAGE_SQUARE_PROFILE_PERMISSIONS_DELETE = 'can_manage_square_profile_permissions_delete',

  // Org settings
  MANAGE_ROLES_AND_PROFILES = 'can_manage_roles_and_profiles',
  VIEW_AUDIT_LOGS = 'can_view_audit_logs',
  CAN_MANAGE_SETTINGS = 'can_manage_settings',
  CAN_MANAGE_ORG_SETTINGS = 'can_manage_org_settings',

  // Users
  USERS_VIEW = 'can_users_view',
  USERS_ADD = 'can_users_add',
  USERS_EDIT = 'can_users_edit',
  USERS_DELETE = 'can_users_delete',
  USERS_REORDER = 'can_users_reorder',
  USERS_UPLOAD_PHOTOS = 'can_user_upload_photos',
  USERS_EXPORT = 'can_users_export',

  // Students
  STUDENTS_VIEW = 'can_students_view',
  STUDENTS_ADD = 'can_students_add',
  STUDENTS_EDIT = 'can_students_edit',
  STUDENTS_DELETE = 'can_students_delete',
  STUDENTS_DETAIN = 'can_students_detain',
  STUDENTS_IMPORT = 'can_students_import',
  STUDENTS_EXPORT = 'can_students_export',
  STUDENTS_RESULTS = 'can_students_results',
  STUDENTS_UPLOAD_PHOTOS = 'can_students_upload_photos',
  STUDENTS_TRANSFER = 'can_students_transfer',
  STUDENTS_ALLOTMENT = 'can_students_allotment',
  STUDENT_INFO_VIEW = 'can_student_info_view',
  STUDENT_ACADEMIC_PERFORMANCE_VIEW = 'can_student_academic_performance_view',
  STUDENT_ATTENDANCE_VIEW = 'can_student_attendance_view',
  STUDENT_PAYMENTS_VIEW = 'can_student_payments_view',
  STUDENT_MEMOS_VIEW = 'can_student_memos_view',
  STUDENT_BACKLOGS_VIEW = 'can_student_backlogs_view',

  // Student Certificate
  CAN_STUDENT_CERTIFICATES_VIEW = 'can_student_certificates_view',
  CAN_STUDENT_CERTIFICATES_EDIT = 'can_student_certificates_edit',
  CAN_STUDENT_CERTIFICATES_DELETE = 'can_student_certificates_delete',
  CAN_STUDENT_CERTIFICATES_ADD = 'can_student_certificates_add',

  //EmailReportCronJobs
  EMAIL_REPORT_CRON_JOBS_VIEW = 'can_email_report_cron_jobs_view',
  EMAIL_REPORT_CRON_JOBS_ADD = 'can_email_report_cron_jobs_add',
  EMAIL_REPORT_CRON_JOBS_EDIT = 'can_email_report_cron_jobs_edit',
  EMAIL_REPORT_CRON_JOBS_DELETE = 'can_email_report_cron_jobs_delete',

  // Subjects
  SUBJECTS_VIEW = 'can_subjects_view',
  SUBJECTS_ADD = 'can_subjects_add',
  SUBJECTS_EDIT = 'can_subjects_edit',
  SUBJECTS_DELETE = 'can_subjects_delete',
  SUBJECTS_EDIT_SUBJECT_INFO = 'can_subjects_edit_subject_info',
  SUBJECTS_BATCH_CONFIG_VIEW = 'can_subjects_batch_config_view',
  SUBJECTS_BATCH_CONFIG_EDIT = 'can_subjects_batch_config_edit',

  // Course Registartions
  COURSE_REGISTRATION_VIEW = 'can_course_registration_view',
  COURSE_REGISTRATION_ADD = 'can_course_registration_add',
  COURSE_REGISTRATION_EDIT = 'can_course_registration_edit',
  COURSE_REGISTRATION_DELETE = 'can_course_registration_delete',

  // Extra Cirricular activities
  EXTRA_CURRICULAR_ACTIVITIES_NEWS_FEED = 'can_extra_curricular_activities_news_feed',
  EXTRA_CURRICULAR_ACTIVITIES_CLUBS = 'can_extra_curricular_activities_clubs',
  EXTRA_CURRICULAR_ACTIVITIES_EVENTS = 'can_extra_curricular_activities_events',

  //Classroom

  CLASSROOM_VIEW = 'can_classroom_view',
  CLASSROOM_EDIT = 'can_classroom_edit',
  CLASSROOM_DELETE = 'can_classroom_delete',
  CLASSROOM_ADD = 'can_classroom_add',
  CLASSROOM_REPORTS = 'can_classroom_reports',
  CLASSROOM_REASSIGN_FACULTY = 'can_classroom_re_assign_faculty',
  CAN_REVOKE_MARKS = 'can_classroom_revoke_marks',
  CAN_CLASSROOM_SUBJECTS_VIEW = 'can_classroom_subjects_view',
  CAN_CLASSROOM_SUBJECT_ATTENDANCE_EDIT = 'can_classroom_subject_attendance_edit',
  CAN_CLASSROOM_SUBJECT_SESSION_DELETE = 'can_classroom_subject_session_delete',
  CAN_CLASSROOM_SESSION_ADD = 'can_classroom_session_add',
  CAN_CLASSROOM_SESSION_EDIT = 'can_classroom_session_edit',
  CAN_CLASSROOM_SESSION_DELETE = 'can_classroom_session_delete',

  CAN_CLASSROOM_SUBJECT_ASSESSMENT_CREATE = 'can_classroom_subject_assessment_create',
  CAN_CLASSROOM_SUBJECT_ASSESSMENT_DELETE = 'can_classroom_subject_assessment_delete',
  CAN_CLASSROOM_SUBJECT_ASSESSMENT_LINK_EXAM = 'can_classroom_subject_assessment_link_exam',

  // Institution
  CAN_INSTITUTION_VIEW = 'can_institutions_view',
  CAN_INSTITUTION_EDIT = 'can_institutions_edit',
  CAN_INSTITUTION_ADD = 'can_institutions_add',
  CAN_INSTITUTION_DELETE = 'can_institutions_delete',
  CAN_INSTITUTION_CONFIGURATION_VIEW = 'can_institution_configuration_view',
  CAN_INSTITUTION_CONFIGURATION_EDIT = 'can_institution_configuration_edit',

  // Infrastructure
  CAN_INFRASTRUCTURE_VIEW = 'can_infrastructure_view',
  CAN_INFRASTRUCTURE_BUILDINGS_ADD = 'can_infrastructure_buildings_add',
  CAN_INFRASTRUCTURE_BUILDINGS_EDIT = 'can_infrastructure_buildings_edit',
  CAN_INFRASTRUCTURE_BUILDINGS_VIEW = 'can_infrastructure_buildings_view',
  CAN_INFRASTRUCTURE_BUILDINGS_DELETE = 'can_infrastructure_buildings_delete',

  CAN_INFRASTRUCTURE_LABS_ADD = 'can_infrastructure_labs_add',
  CAN_INFRASTRUCTURE_LABS_EDIT = 'can_infrastructure_labs_edit',
  CAN_INFRASTRUCTURE_LABS_VIEW = 'can_infrastructure_labs_view',
  CAN_INFRASTRUCTURE_LABS_DELETE = 'can_infrastructure_labs_delete',

  CAN_INFRASTRUCTURE_CLASSROOMS_ADD = 'can_infrastructure_classrooms_add',
  CAN_INFRASTRUCTURE_CLASSROOMS_EDIT = 'can_infrastructure_classrooms_edit',
  CAN_INFRASTRUCTURE_CLASSROOMS_VIEW = 'can_infrastructure_classrooms_view',
  CAN_INFRASTRUCTURE_CLASSROOMS_DELETE = 'can_infrastructure_classrooms_delete',

  CAN_INFRASTRUCTURE_EQUIPMENTS_ADD = 'can_infrastructure_equipments_add',
  CAN_INFRASTRUCTURE_EQUIPMENTS_EDIT = 'can_infrastructure_equipments_edit',
  CAN_INFRASTRUCTURE_EQUIPMENTS_VIEW = 'can_infrastructure_equipments_view',
  CAN_INFRASTRUCTURE_EQUIPMENTS_DELETE = 'can_infrastructure_equipments_delete',
  CAN_INFRASTRUCTURE_EQUIPMENTS_HISTORY_MANAGE = 'can_infrastructure_equipments_history_manage',
  CAN_INFRASTRUCTURE_EQUIPMENTS_DOCUMENTS_MANAGE = 'can_infrastructure_equipments_documents_manage',

  // Feed
  CAN_ADD_FEED = 'can_feed_add',

  // Degrees
  CAN_DEGREES_ADD = 'can_degrees_add',
  CAN_DEGREES_DELETE = 'can_degrees_delete',
  CAN_DEGREES_EDIT = 'can_degrees_edit',
  CAN_DEGREES_VIEW = 'can_degrees_view',

  // Programs
  CAN_PROGRAMS_ADD = 'can_programs_add',
  CAN_PROGRAMS_DELETE = 'can_programs_delete',
  CAN_PROGRAMS_EDIT = 'can_programs_edit',
  CAN_PROGRAMS_VIEW = 'can_programs_view',

  // Semesters
  CAN_SEMESTERS_ADD = 'can_semesters_add',
  CAN_SEMESTERS_DELETE = 'can_semesters_delete',
  CAN_SEMESTERS_EDIT = 'can_semesters_edit',
  CAN_SEMESTERS_VIEW = 'can_semesters_view',

  // Curriculums
  CAN_CURRICULUMS_ADD = 'can_curriculums_add',
  CAN_CURRICULUMS_EDIT = 'can_curriculums_edit',
  CAN_CURRICULUMS_DELETE = 'can_curriculums_delete',
  CAN_CURRICULUMS_VIEW = 'can_curriculums_view',

  // Subject types
  SUBJECT_TYPE_VIEW = 'can_subject_types_view',
  SUBJECT_TYPE_ADD = 'can_subject_types_add',
  SUBJECT_TYPE_EDIT = 'can_subject_types_edit',
  SUBJECT_TYPE_DELETE = 'can_subject_types_delete',

  // Assessment Type
  ASSESSMENT_TYPE_VIEW = 'can_assessment_types_view',
  ASSESSMENT_TYPE_ADD = 'can_assessment_types_add',
  ASSESSMENT_TYPE_EDIT = 'can_assessment_types_edit',
  ASSESSMENT_TYPE_DELETE = 'can_assessment_types_delete',

  // Assessment Templates
  CAN_ASSESSMENT_TEMPLATES_ADD = 'can_assessment_templates_add',
  CAN_ASSESSMENT_TEMPLATES_EDIT = 'can_assessment_templates_edit',
  CAN_ASSESSMENT_TEMPLATES_VIEW = 'can_assessment_templates_view',
  CAN_ASSESSMENT_TEMPLATES_DELETE = 'can_assessment_templates_delete',

  // Assessment Rules
  CAN_ASSESSMENT_RULES_ADD = 'can_assessment_rules_add',
  CAN_ASSESSMENT_RULES_DELETE = 'can_assessment_rules_delete',
  CAN_ASSESSMENT_RULES_EDIT = 'can_assessment_rules_edit',
  CAN_ASSESSMENT_RULES_VIEW = 'can_assessment_rules_view',

  // Schools
  SCHOOLS_VIEW = 'can_schools_view',
  SCHOOLS_ADD = 'can_schools_add',
  SCHOOLS_EDIT = 'can_schools_edit',
  SCHOOLS_DELETE = 'can_schools_delete',

  // Master Subjects
  CAN_MASTER_SUBJECT_VIEW = 'can_master_subject_view',
  CAN_MASTER_SUBJECT_ADD = 'can_master_subject_add',
  CAN_MASTER_SUBJECT_EDIT = 'can_master_subject_edit',
  CAN_MASTER_SUBJECT_DELETE = 'can_master_subject_delete',

  // Analytics
  CAN_BIRDS_EYE_VIEW = 'can_birds_eye_view',
  // Tasks
  CAN_TASKS_ADD = 'can_tasks_add',
  CAN_TASKS_DELETE = 'can_tasks_delete',
  CAN_TASKS_EDIT = 'can_tasks_edit',
  CAN_TASKS_VIEW = 'can_tasks_view',
  CAN_TASKS_CHANGE_STATUS = 'can_tasks_change_status',

  // Academic Calendar
  ACADEMIC_CALENDAR_VIEW = 'can_academic_calendar_view',
  ACADEMIC_CALENDAR_EVENT_ADD = 'can_academic_calendar_event_add',
  ACADEMIC_CALENDAR_EVENT_EDIT = 'can_academic_calendar_event_edit',
  ACADEMIC_CALENDAR_EVENT_DELETE = 'can_academic_calendar_event_delete',
  // Academic calendar timeline
  CAN_ACADEMIC_CALENDAR_TIMELINE_VIEW = 'can_academic_calendar_timeline_view',
  // Time Slots
  CAN_TIME_SLOTS_VIEW = 'can_time_slots_view',
  CAN_TIME_SLOTS_ADD = 'can_time_slots_add',
  CAN_TIME_SLOTS_EDIT = 'can_time_slots_edit',
  CAN_TIME_SLOTS_DELETE = 'can_time_slots_delete',

  //Departments
  CAN_DEPARTMENTS_VIEW = 'can_departments_view',
  CAN_DEPARTMENTS_ADD = 'can_departments_add',
  CAN_DEPARTMENTS_EDIT = 'can_departments_edit',
  CAN_DEPARTMENTS_DELETE = 'can_departments_delete',

  //Designations
  DESIGNATIONS_ADD = 'can_designations_add',
  DESIGNATIONS_DELETE = 'can_designations_delete',
  DESIGNATIONS_EDIT = 'can_designations_edit',
  DESIGNATIONS_VIEW = 'can_designations_view',

  // Form Builder
  CAN_FORM_BUILDER_VIEW = 'can_form_builder_view',
  CAN_FORM_BUILDER_EDIT = 'can_form_builder_edit',
  CAN_FORM_BUILDER_ADD = 'can_form_builder_add',
  CAN_FORM_BUILDER_DELETE = 'can_form_builder_delete',

  // Surveys
  CAN_SURVEYS_VIEW = 'can_surveys_view',
  CAN_SURVEYS_EDIT = 'can_surveys_edit',
  CAN_SURVEYS_ADD = 'can_surveys_add',
  CAN_SURVEYS_DELETE = 'can_surveys_delete',

  //Configuration

  CAN_CONFIGURATION_VIEW = 'can_configuration_view',

  //Digital Notice Board
  CAN_NOTICE_BOARD_VIEW = 'can_notice_board_view',
  CAN_NOTICE_BOARD_EDIT = 'can_notice_board_edit',
  CAN_NOTICE_BOARD_ADD = 'can_notice_board_add',
  CAN_NOTICE_BOARD_DELETE = 'can_notice_board_delete',

  //Research Projects
  CAN_RESEARCH_PROJECT_VIEW = 'can_research_project_view',
  CAN_RESEARCH_PROJECT_EDIT = 'can_research_project_edit',
  CAN_RESEARCH_PROJECT_ADD = 'can_research_project_add',
  CAN_RESEARCH_PROJECT_DELETE = 'can_research_project_delete',

  // Enroll X

  // manage exams profile_permissions
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_VIEW = 'can_manage_enroll_x_profile_permissions_view',
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_ADD = 'can_manage_enroll_x_profile_permissions_add',
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_EDIT = 'can_manage_enroll_x_profile_permissions_edit',
  CAN_MANAGE_ENROLL_X_PROFILE_PERMISSIONS_DELETE = 'can_manage_enroll_x_profile_permissions_delete',

  // Leads
  CAN_LEADS_VIEW = 'can_leads_view',
  CAN_LEADS_ADD = 'can_leads_add',
  CAN_LEADS_EDIT = 'can_leads_edit',
  CAN_LEADS_DELETE = 'can_leads_delete',
  CAN_LEADS_IMPORT = 'can_leads_import',
  CAN_ASSIGN_COUNSELLOR_LEADS = 'can_leads_assign_counsellor',
  CAN_LEADS_CONVERT_TO_ADMISSION = 'can_leads_convert_to_admission',

  // Counsellor
  CAN_COUNSELLOR_VIEW = 'can_counsellor_view',
  CAN_COUNSELLOR_ADD = 'can_counsellor_add',
  CAN_COUNSELLOR_DELETE = 'can_counsellor_delete',
  CAN_COUNSELLOR_REPORT_VIEW = 'can_counsellor_report_view',

  // Concession enroll_x
  CAN_ENROLL_X_CONCESSION_VIEW = 'can_enroll_x_concession_view',
  CAN_ENROLL_X_CONCESSION_CHANGE_STATUS = 'can_enroll_x_concession_change_status',

  // Notifications
  CAN_NOTIFICATION_ADD = 'can_notification_add',
  CAN_NOTIFICATION_EDIT = 'can_notification_edit',
  CAN_NOTIFICATION_DELETE = 'can_notification_delete',
  CAN_NOTIFICATION_VIEW = 'can_notification_view',

  // Admissions
  ADMISSIONS_ADD = 'can_admissions_add',
  ADMISSIONS_VIEW = 'can_admissions_view',
  ADMISSIONS_EDIT = 'can_admissions_edit',
  ADMISSIONS_DELETE = 'can_admissions_delete',
  ADMISSIONS_CHANGE_STATUS = 'can_admissions_change_status',
  ADMISSIONS_IMPORT = 'can_admissions_import',
  ADMISSIONS_EXPORT = 'can_admissions_export',
  ADMISSIONS_CONFIRM = 'can_admissions_confirm',
  CAN_ADMISSION_REJECT = 'can_admissions_reject',
  CAN_ADMISSIONS_DASHBOARD_VIEW = 'can_admission_dashboard_view',
  CAN_ADMISSIONS_LEAD_REMARKS = 'can_admission_lead_remarks',
  CAN_ADMISSIONS_GRAPH_VIEW = 'can_admission_graph_view',
  CAN_ADMISSIONS_CONFIRMED_STUDENTS = 'can_admissions_confirmed_students',
  CAN_ENROLL_X_AUDIT_LOGS = 'can_enroll_x_view_audit_logs',
  CAN_ADMISSION_APPROVAL = 'can_admission_approvals',

  // CET & PHD
  CAN_PHD_FORM_VIEW = 'can_admissions_view_phd_applications',
  CAN_PHD_FORM_DOWNLOAD = 'can_admissions_download_phd_applications',
  CAN_CET_VIEW = 'can_admissions_view_cet',
  CAN_EDIT_VIEW = 'can_admissions_edit_cet',
  CAN_CET_DOWNLOAD = 'can_admissions_download_cet',

  // Settings
  CAN_MANAGE_ENROLL_X_SETTINGS = 'can_enroll_x_manage_settings',
  // Quotas
  CAN_QUOTAS_EDIT = 'can_quotas_edit',
  CAN_QUOTAS_DELETE = 'can_quotas_delete',
  CAN_QUOTAS_ADD = 'can_quotas_add',
  CAN_QUOTAS_VIEW = 'can_quotas_view',

  // caste
  CAN_CASTE_EDIT = 'can_caste_edit',
  CAN_CASTE_DELETE = 'can_caste_delete',
  CAN_CASTE_ADD = 'can_caste_add',
  CAN_CASTE_VIEW = 'can_caste_view',

  // Lead Status
  CAN_LEAD_STATUS_VIEW = 'can_lead_status_view',
  CAN_LEAD_STATUS_EDIT = 'can_lead_status_edit',
  CAN_LEAD_STATUS_ADD = 'can_lead_status_add',
  CAN_LEAD_STATUS_DELETE = 'can_lead_status_delete',

  // Lead Sources
  CAN_LEAD_SOURCES_VIEW = 'can_lead_sources_view',
  CAN_LEAD_SOURCES_ADD = 'can_lead_sources_add',
  CAN_LEAD_SOURCES_EDIT = 'can_lead_sources_edit',
  CAN_LEAD_SOURCES_DELETE = 'can_lead_sources_delete',

  // Exams

  // manage exams profile_permissions
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_VIEW = 'can_manage_exams_profile_permissions_view',
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_ADD = 'can_manage_exams_profile_permissions_add',
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_EDIT = 'can_manage_exams_profile_permissions_edit',
  CAN_MANAGE_EXAMS_PROFILE_PERMISSIONS_DELETE = 'can_manage_exams_profile_permissions_delete',

  // End Semester Examination
  CAN_END_SEMESTER_EXAMINATIONS_VIEW = 'can_end_semester_examinations_view',
  CAN_END_SEMESTER_EXAMINATIONS_ADD = 'can_end_semester_examinations_add',
  CAN_END_SEMESTER_EXAMINATIONS_EDIT = 'can_end_semester_examinations_edit',
  CAN_END_SEMESTER_EXAMINATIONS_ARCHIVE_EXAM = 'can_end_semester_examinations_archive_exam',
  CAN_END_SEMESTER_EXAMINATIONS_DELETE = 'can_end_semester_examinations_delete',
  CAN_END_SEMESTER_EXAMINATIONS_NOTIFICATION_DETAILS_VIEW = 'can_end_semester_examinations_notification_details_view',

  // Registrations
  CAN_EXAM_REGISTARTIONS_VIEW = 'can_exam_registrations_view',
  CAN_EXAM_REGISTARTIONS_ADD = 'can_exam_registrations_add',
  CAN_EXAM_REGISTARTIONS_CHALLAN_UPLOAD = 'can_exam_registrations_challan_upload',
  CAN_EXAM_REGISTARTIONS_SUBMIT = 'can_exam_registrations_submit',

  //Challan Upload
  CAN_CHALLAN_UPLOAD_VIEW = 'can_challan_upload_view',
  CAN_CHALLAN_REGISTRATION_VIEW = 'can_challan_registrations_view',
  CAN_CHALLAN_REGISTRATION_ADD = 'can_challan_registrations_add',
  CAN_CHALLAN_UPLOAD_ADD = 'can_challan_upload_add',

  // Question Paper Upload
  CAN_QUESTION_PAPER_UPLOAD_VIEW = 'can_question_paper_upload_view',
  CAN_QUESTION_PAPER_UPLOAD_ADD = 'can_question_paper_upload_add',
  CAN_QUESTION_PAPER_UPLOAD_EDIT = 'can_question_paper_upload_edit',

  //settings
  CAN_EXAMS_SETTINGS_VIEW = 'can_exams_settings_view',

  // Fee configuration
  EXAM_FEE_CONFIGURATION_VIEW = 'can_exam_fee_configuration_view',
  EXAM_FEE_CONFIGURATION_ADD = 'can_exam_fee_configuration_add',

  // Time table
  CAN_EXAM_TIMETABLE_VIEW = 'can_exam_timetable_view',
  CAN_EXAM_TIMETABLE_ADD = 'can_exam_timetable_add',
  CAN_EXAM_TIMETABLE_EDIT = 'can_exam_timetable_edit',
  CAN_EXAM_TIMETABLE_DELETE = 'can_exam_timetable_delete',

  // Hall tickets
  CAN_HALL_TICKETS_VIEW = 'can_hall_tickets_view',
  CAN_HALL_TICKETS_DOWNLOAD = 'can_hall_tickets_download',

  // OMRS
  CAN_OMRS_VIEW = 'can_omrs_view',
  CAN_OMRS_UPDATE = 'can_omrs_update',
  CAN_OMRS_GENERATE = 'can_omrs_generate',
  CAN_OMRS_DOWNLOAD = 'can_omrs_download',

  // Paper Configuration
  CAN_PAPER_CONFIGURATION_VIEW = 'can_paper_configuration_view',
  CAN_PAPER_CONFIGURATION_ADD = 'can_paper_configuration_add',
  CAN_PAPER_CONFIGURATION_EDIT = 'can_paper_configuration_edit',
  CAN_PAPER_CONFIGURATION_DELETE = 'can_paper_configuration_delete',
  CAN_PAPER_CONFIGURATION_DOWNLOAD = 'can_paper_configuration_download',

  // D Form
  CAN_D_FORM_VIEW = 'can_d_forms_view',
  CAN_D_FORM_ADD = 'can_d_forms_add',
  CAN_D_FORM_DOWNLOAD = 'can_d_forms_download',

  // Bundling
  CAN_VIEW_ANSWER_SHEET_REPORT = 'can_view_answer_sheet_report',
  CAN_BUNDLING_VIEW = 'can_bundling_view',
  CAN_BUNDLING_ADD = 'can_bundling_add',
  CAN_BUNDLING_EDIT = 'can_bundling_edit',
  CAN_BUNDLING_DELETE = 'can_bundling_delete',
  CAN_BUNDLING_UPDATE_BUNDLE_STATUS = 'can_bundling_update_bundle_status',
  CAN_BUNDLING_BUNDLE_SHEETS_ADD = 'can_bundling_bundle_sheets_add',
  CAN_BUNDLING_BUNDLE_SHEETS_REMOVE = 'can_bundling_bundle_sheets_remove',

  // Internal Marks
  CAN_INTERNAL_MARKS_VIEW = 'can_internal_marks_view',
  CAN_INTERNAL_MARKS_ADD = 'can_internal_marks_add',
  CAN_INTERNAL_MARKS_EDIT = 'can_internal_marks_edit',
  CAN_INTERNAL_MARKS_IMPORT = 'can_internal_marks_import',
  CAN_INTERNAL_MARKS_IMPORT_LMS = 'can_internal_marks_import_lms',

  // External Marks
  CAN_EXTERNAL_MARKS_VIEW = 'can_external_marks_view',
  CAN_EXTERNAL_MARKS_ADD = 'can_external_marks_add',
  CAN_EXTERNAL_MARKS_EDIT = 'can_external_marks_edit',

  // Result Processing
  CAN_RESULTS_PROCESSING_VIEW = 'can_results_processing_view_reports',
  CAN_RESULTS_PROCESSING_GENERATE_MEMOS = 'can_results_processing_generate_memos',
  CAN_RESULTS_PROCESSING_MODERATION_AND_GRAFTING = 'can_results_processing_moderation_and_grafting',
  CAN_RESULTS_PROCESSING_PUBLISH_RESULTS = 'can_results_processing_publish_results',
  CAN_RESULTS_PROCESSING_UPDATE_INTERNAL_MARKS = 'can_results_processing_update_internal_marks',

  // Revaluation Fee Configuration
  CAN_REVALUATION_FEE_CONFIGURATION_VIEW = 'can_revaluation_fee_configuration_view',
  CAN_REVALUATION_FEE_CONFIGURATION_ADD = 'can_revaluation_fee_configuration_add',

  //Revaluation
  CAN_REVALUATION_VIEW = 'can_revaluation_view',
  CAN_REVALUATION_REGISTRATIONS_ADD = 'can_revaluation_add_registrations',
  CAN_REVALUATION_OMRS = 'can_revaluation_omrs',
  CAN_REVALUATION_ADD_MARKS = 'can_revaluation_add_marks',
  CAN_REVALUATION_EDIT_MARKS = 'can_revaluation_edit_marks',
  CAN_REVALUATION_PROCESS_REVAL = 'can_revaluation_process_reval',
  CAN_REVALUATION_VIEW_REPORTS = 'can_revaluation_view_reports',
  CAN_REVALUATION_GENERATE_MEMOS = 'can_revaluation_generate_memos',

  // Internal Examinations
  CAN_INTERNAL_EXAMINATIONS_VIEW = 'can_internal_examinations_view',
  CAN_INTERNAL_EXAMINATIONS_ADD = 'can_internal_examinations_add',
  CAN_INTERNAL_EXAMINATIONS_EDIT = 'can_internal_examinations_edit',
  CAN_INTERNAL_EXAMINATIONS_DELETE = 'can_internal_examinations_delete',
  CAN_INTERNAL_EXAMINATIONS_MANAGE_EXAM_FEE = 'can_internal_examinations_manage_exam_fee',

  CAN_INTERNAL_EXAM_PAPER_CONFIGURATION_VIEW = 'can_internal_exam_paper_configuration_view',
  CAN_INTERNAL_EXAM_PAPER_CONFIGURATION_ADD = 'can_internal_exam_paper_configuration_add',
  CAN_INTERNAL_EXAM_PAPER_CONFIGURATION_EDIT = 'can_internal_exam_paper_configuration_edit',
  CAN_INTERNAL_EXAM_PAPER_CONFIGURATION_DELETE = 'can_internal_exam_paper_configuration_delete',

  CAN_INTERNAL_EXAM_TIMETABLE_VIEW = 'can_internal_exam_timetable_view',
  CAN_INTERNAL_EXAM_TIMETABLE_ADD = 'can_internal_exam_timetable_add',
  CAN_INTERNAL_EXAM_TIMETABLE_EDIT = 'can_internal_exam_timetable_edit',
  CAN_INTERNAL_EXAM_TIMETABLE_DELETE = 'can_internal_exam_timetable_delete',

  // Seating Plan
  SEATING_PLAN = 'can_examinations_seating_plan',
  CAN_SEATING_PLAN_VIEW = 'can_seating_plan_view',
  CAN_SEATING_PLAN_ADD = 'can_seating_plan_add',
  CAN_SEATING_PLAN_DELETE = 'can_seating_plan_delete',

  // Invigilations
  CAN_INVIGILATIONS_VIEW = 'can_invigilations_view',
  CAN_INVIGILATIONS_ADD = 'can_invigilations_add',

  // Settings
  CAN_MANAGE_EXAMS_SETTINGS = 'can_exams_manage_settings',
  // Evaluators
  CAN_EVALUATORS_VIEW = 'can_evaluators_view',
  CAN_EVALUATORS_ADD = 'can_evaluators_add',
  CAN_EVALUATORS_EDIT = 'can_evaluators_edit',
  CAN_EVALUATORS_DELETE = 'can_evaluators_delete',

  // Grades
  CAN_GRADES_ADD = 'can_grades_add',
  CAN_GRADES_EDIT = 'can_grades_edit',
  CAN_GRADES_DELETE = 'can_grades_delete',
  CAN_GRADES_VIEW = 'can_grades_view',

  // Rooms
  CAN_EXAM_ROOM_VIEW = 'can_exam_rooms_view',
  CAN_EXAM_ROOM_ADD = 'can_exam_rooms_add',
  CAN_EXAM_ROOM_EDIT = 'can_exam_rooms_edit',
  CAN_EXAM_ROOM_DELETE = 'can_exam_rooms_delete',

  // Marks Division
  CAN_MARKS_DIVISION_VIEW = 'can_marks_division_view',
  CAN_MARKS_DIVISION_ADD = 'can_marks_division_add',
  CAN_MARKS_DIVISION_EDIT = 'can_marks_division_edit',
  CAN_MARKS_DIVISION_DELETE = 'can_marks_division_delete',

  //  Time slots
  CAN_EXAM_TIME_SLOTS_VIEW = 'can_exam_time_slots_view',
  CAN_EXAM_TIME_SLOTS_ADD = 'can_exam_time_slots_add',
  CAN_EXAM_TIME_SLOTS_EDIT = 'can_exam_time_slots_edit',
  CAN_EXAM_TIME_SLOTS_DELETE = 'can_exam_time_slots_delete',

  CAN_ADMIN_VIEW = 'can_admin_view',

  //HRMS
  //Profiles
  CAN_MANAGE_HRMS_PROFILE_PERMISSIONS_VIEW = 'can_manage_hrms_profile_permissions_view',
  CAN_MANAGE_HRMS_PROFILE_PERMISSIONS_ADD = 'can_manage_hrms_profile_permissions_add',
  CAN_MANAGE_HRMS_PROFILE_PERMISSIONS_EDIT = 'can_manage_hrms_profile_permissions_edit',
  CAN_MANAGE_HRMS_PROFILE_PERMISSIONS_DELETE = 'can_manage_hrms_profile_permissions_delete',

  //Infomation
  CAN_VIEW_INFORMATION = 'can_view_information',
  CAN_EDIT_INFORMATION = 'can_edit_information',
  CAN_EDIT_SPECIAL_INFORMATION = 'can_edit_special_information',

  //Leave Tracker
  CAN_VIEW_LEAVE_TRACKER = 'can_view_leave_tracker',
  CAN_APPLY_LEAVE = 'can_apply_leave',

  //Employees
  CAN_VIEW_EMPLOYEES = 'can_view_employees',
  CAN_EDIT_EMPLOYEES = 'can_edit_employees',
  CAN_CREATE_EMPLOYEES = 'can_create_employees',
  CAN_IMPORT_EMPLOYEES = 'can_import_employees',

  //PunchLogs
  CAN_VIEW_PUNCH_LOGS = 'can_view_punch_logs',

  //Time Sheet
  CAN_VIEW_TIME_SHEET = 'can_view_time_sheet',
  CAN_EDIT_TIME_SHEET = 'can_edit_time_sheet',
  CAN_IMPORT_TIME_SHEET = 'can_import_time_sheet',
  CAN_EXPORT_TIME_SHEET = 'can_export_time_sheet',
  CAN_GENERATE_TIME_SHEET = 'can_generate_time_sheet',

  //Loss Of Pay
  CAN_VIEW_LOSS_OF_PAY = 'can_view_loss_of_pay',

  //Leave Usages
  CAN_VIEW_LEAVES_USAGES = 'can_view_leaves_usages',
  CAN_EDIT_LEAVES_USAGES = 'can_edit_leaves_usages',
  CAN_IMPORT_LEAVES_USAGES = 'can_import_leaves_usages',
  CAN_EXPORT_LEAVES_USAGES = 'can_export_leaves_usages',

  //Leave Requests
  CAN_VIEW_LEAVES_REQUESTS = 'can_view_leaves_requests',
  CAN_VIEW_PAST_LEAVES_REQUESTS = 'can_view_past_leaves_requests',
  CAN_CREATE_LEAVES_REQUESTS = 'can_create_leaves_requests',
  CAN_APPROVE_LEAVE_REQUESTS = 'can_approve_leave_requests',
  CAN_REJECT_LEAVE_REQUESTS = 'can_reject_leave_requests',
  CAN_CANCEL_LEAVE_REQUESTS = 'can_cancel_leave_requests',

  //All Leave Requests
  VIEW_ALL_LEAVE_REQUESTS = 'can_view_all_leave_requests',
  CANCEL_ALL_LEAVE_REQUESTS = 'can_cancel_all_leave_requests',
  EXPORT_ALL_LEAVE_REQUESTS = 'can_export_all_leave_requests',

  //Departments
  CAN_VIEW_DEPARTMENTS = 'can_view_departments',
  CAN_ADD_DEPARTMENTS = 'can_add_departments',
  CAN_IMPORT_DEPARTMENTS = 'can_import_departments',
  CAN_EXPORT_DEPARTMENTS = 'can_export_departments',
  CAN_EDIT_DEPARTMENTS = 'can_edit_departments',

  //Designations
  CAN_VIEW_DESIGNATIONS = 'can_view_designations',
  CAN_ADD_DESIGNATIONS = 'can_add_designations',
  CAN_IMPORT_DESIGNATIONS = 'can_import_designations',
  CAN_EXPORT_DESIGNATIONS = 'can_export_designations',
  CAN_EDIT_DESIGNATIONS = 'can_edit_designations',

  //Leave Types
  CAN_VIEW_LEAVE_TYPES = 'can_view_leave_types',
  CAN_ADD_LEAVE_TYPES = 'can_add_leave_types',
  CAN_EDIT_LEAVE_TYPES = 'can_edit_leave_types',

  //Groups
  CAN_VIEW_GROUPS = 'can_view_groups',
  CAN_ADD_GROUPS = 'can_add_groups',
  CAN_EDIT_GROUPS_TIME_CONFIG = 'can_edit_groups_time_config',
  CAN_EDIT_GROUPS_LEAVE_CONFIG = 'can_edit_groups_leave_config',

  //Database Configurations
  CAN_VIEW_DATABASE_CONFIG = 'can_view_database_config',
  CAN_EDIT_DATABASE_CONFIG = 'can_edit_database_config',

  //  Feedback
  CAN_VIEW_FEEDBACKS = 'can_view_feedbacks',
  CAN_CREATE_FEEDBACK = 'can_create_feedback',
  CAN_MANAGE_TARGET_AUDIENCE = 'can_manage_target_audience',
  CAN_CONFIGURE_FEEDBACK_FORM = 'can_configure_feedback_form',
  CAN_CHANGE_FEEDBACK_STATUS = 'can_change_feedback_status',

  //Feedback Questions
  CAN_VIEW_FEEDBACK_QUESTIONS = 'can_view_feedback_questions',
  CAN_CREATE_FEEDBACK_QUESTION = 'can_create_feedback_question',
  CAN_EDIT_FEEDBACK_QUESTION = 'can_edit_feedback_question',
  CAN_FINALIZE_FEEDBACK_QUESTION = 'can_finalize_feedback_question',
  CAN_DELETE_FEEDBACK_QUESTION = 'can_delete_feedback_question',

  // Admin Permissions
  CAN_MANAGE_ADMIN_PROFILE_PERMISSIONS_VIEW = 'can_manage_admin_profile_permissions_view',
  CAN_MANAGE_ADMIN_PROFILE_PERMISSIONS_ADD = 'can_manage_admin_profile_permissions_add',
  CAN_MANAGE_ADMIN_PROFILE_PERMISSIONS_EDIT = 'can_manage_admin_profile_permissions_edit',
  CAN_MANAGE_ADMIN_PROFILE_PERMISSIONS_DELETE = 'can_manage_admin_profile_permissions_delete',
  CAN_ADMIN_MANAGE_SETTINGS = 'can_admin_manage_settings',
  CAN_ADMIN_MANAGE_ORG_SETTINGS = 'can_admin_manage_org_settings',
  CAN_MANAGE_USER_PROFILES = 'can_manage_user_profiles',
  CAN_ADMIN_INSTITUTIONS_VIEW = 'can_admin_institutions_view',
  CAN_ADMIN_INSTITUTIONS_ADD = 'can_admin_institutions_add',
  CAN_ADMIN_INSTITUTIONS_EDIT = 'can_admin_institutions_edit',
  CAN_ADMIN_INSTITUTIONS_DELETE = 'can_admin_institutions_delete',
  CAN_ADMIN_INSTITUTION_CONFIGURATION_VIEW = 'can_admin_institution_configuration_view',
  CAN_ADMIN_INSTITUTION_CONFIGURATION_EDIT = 'can_admin_institution_configuration_edit',
  CAN_ADMIN_DEGREES_ADD = 'can_admin_degrees_add',
  CAN_ADMIN_DEGREES_VIEW = 'can_admin_degrees_view',
  CAN_ADMIN_DEGREES_EDIT = 'can_admin_degrees_edit',
  CAN_ADMIN_DEGREES_DELETE = 'can_admin_degrees_delete',
  CAN_ADMIN_SEMESTERS_VIEW = 'can_admin_semesters_view',
  CAN_ADMIN_SEMESTERS_ADD = 'can_admin_semesters_add',
  CAN_ADMIN_SEMESTERS_EDIT = 'can_admin_semesters_edit',
  CAN_ADMIN_SEMESTERS_DELETE = 'can_admin_semesters_delete',
  CAN_ADMIN_REGULATION_BATCHES_VIEW = 'can_admin_regulation_batches_view',
  CAN_ADMIN_REGULATION_BATCHES_ADD = 'can_admin_regulation_batches_add',
  CAN_ADMIN_REGULATION_BATCHES_EDIT = 'can_admin_regulation_batches_edit',
  CAN_ADMIN_REGULATION_BATCHES_DELETE = 'can_admin_regulation_batches_delete',
  CAN_ADMIN_DEPARTMENTS_VIEW = 'can_admin_departments_view',
  CAN_ADMIN_DEPARTMENTS_ADD = 'can_admin_departments_add',
  CAN_ADMIN_DEPARTMENTS_EDIT = 'can_admin_departments_edit',
  CAN_ADMIN_DEPARTMENTS_DELETE = 'can_admin_departments_delete',
  CAN_ADMIN_SUBJECT_TYPES_VIEW = 'can_admin_subject_types_view',
  CAN_ADMIN_SUBJECT_TYPES_ADD = 'can_admin_subject_types_add',
  CAN_ADMIN_SUBJECT_TYPES_EDIT = 'can_admin_subject_types_edit',
  CAN_ADMIN_SUBJECT_TYPES_DELETE = 'can_admin_subject_types_delete',
  CAN_ADMIN_PROGRAMS_ADD = 'can_admin_programs_add',
  CAN_ADMIN_PROGRAMS_VIEW = 'can_admin_programs_view',
  CAN_ADMIN_PROGRAMS_EDIT = 'can_admin_programs_edit',
  CAN_ADMIN_PROGRAMS_DELETE = 'can_admin_programs_delete',
  CAN_ADMIN_SUBJECTS_VIEW = 'can_admin_subjects_view',
  CAN_ADMIN_SUBJECTS_ADD = 'can_admin_subjects_add',
  CAN_ADMIN_SUBJECTS_EDIT = 'can_admin_subjects_edit',
  CAN_ADMIN_SUBJECTS_DELETE = 'can_admin_subjects_delete',
  CAN_ADMIN_SUBJECTS_EDIT_SUBJECT_INFO = 'can_admin_subjects_edit_subject_info',
  CAN_ADMIN_SUBJECTS_BATCH_CONFIG_VIEW = 'can_admin_subjects_batch_config_view',
  CAN_ADMIN_SUBJECTS_BATCH_CONFIG_EDIT = 'can_admin_subjects_batch_config_edit',
  CAN_ADMIN_STUDENTS_VIEW = 'can_admin_students_view',
  CAN_ADMIN_STUDENTS_ADD = 'can_admin_students_add',
  CAN_ADMIN_STUDENTS_EDIT = 'can_admin_students_edit',
  CAN_ADMIN_STUDENTS_DETAIN = 'can_admin_students_detain',
  CAN_ADMIN_STUDENTS_IMPORT = 'can_admin_students_import',
  CAN_ADMIN_STUDENTS_EXPORT = 'can_admin_students_export',
  CAN_ADMIN_STUDENTS_RESULTS = 'can_admin_students_results',
  CAN_ADMIN_STUDENTS_UPLOAD_PHOTOS = 'can_admin_students_upload_photos',
  CAN_ADMIN_STUDENTS_TRANSFER = 'can_admin_students_transfer',
  CAN_ADMIN_STUDENTS_ALLOTMENT = 'can_admin_students_allotment',
  CAN_ADMIN_STUDENT_INFO_VIEW = 'can_admin_student_info_view',
  CAN_ADMIN_STUDENT_ACADEMIC_PERFORMANCE_VIEW = 'can_admin_student_academic_performance_view',
  CAN_ADMIN_STUDENT_ATTENDANCE_VIEW = 'can_admin_student_attendance_view',
  CAN_ADMIN_STUDENT_PAYMENTS_VIEW = 'can_admin_student_payments_view',
  CAN_ADMIN_STUDENT_MEMOS_VIEW = 'can_admin_student_memos_view',
  CAN_ADMIN_STUDENT_BACKLOGS_VIEW = 'can_admin_student_backlogs_view',
  CAN_ADMIN_USERS_VIEW = 'can_admin_users_view',
  CAN_ADMIN_USERS_ADD = 'can_admin_users_add',
  CAN_ADMIN_USERS_EDIT = 'can_admin_users_edit',
  CAN_ADMIN_USERS_DELETE = 'can_admin_users_delete',
  CAN_ADMIN_USERS_PHOTOS_UPLOAD = 'can_admin_users_photos_upload',
  CAN_ADMIN_USERS_EXPORT = 'can_admin_users_export',
  CAN_ADMIN_DESIGNATIONS_ADD = 'can_admin_designations_add',
  CAN_ADMIN_DESIGNATIONS_EDIT = 'can_admin_designations_edit',
  CAN_ADMIN_DESIGNATIONS_VIEW = 'can_admin_designations_view',
  CAN_ADMIN_DESIGNATIONS_DELETE = 'can_admin_designations_delete',
}

export interface IPermissions {
  can_manage_roles_and_profiles: boolean
  can_view_audit_logs: boolean
  can_manage_settings: boolean
  can_manage_org_settings: boolean
  can_manage_square_profile_permissions_view: boolean
  can_manage_square_profile_permissions_add: boolean
  can_manage_square_profile_permissions_edit: boolean
  can_manage_square_profile_permissions_delete: boolean
  can_users_view: boolean
  can_users_add: boolean
  can_users_edit: boolean
  can_users_delete: boolean
  can_users_reorder: boolean
  can_user_upload_photos: boolean
  can_users_export: boolean
  can_email_report_cron_jobs_view: boolean
  can_email_report_cron_jobs_add: boolean
  can_email_report_cron_jobs_edit: boolean
  can_email_report_cron_jobs_delete: boolean
  can_students_view: boolean
  can_students_add: boolean
  can_students_edit: boolean
  can_students_delete: boolean
  can_students_detain: boolean
  can_students_import: boolean
  can_students_export: boolean
  can_students_results: boolean
  can_students_upload_photos: boolean
  can_students_transfer: boolean
  can_students_allotment: boolean
  can_student_info_view: boolean
  can_student_academic_performance_view: boolean
  can_student_attendance_view: boolean
  can_student_payments_view: boolean
  can_student_memos_view: boolean
  can_student_backlogs_view: boolean
  can_subjects_view: boolean
  can_subjects_add: boolean
  can_subjects_edit: boolean
  can_subjects_delete: boolean
  can_subjects_edit_subject_info: boolean
  can_subjects_batch_config_edit: boolean
  can_subjects_batch_config_view: boolean
  can_course_registration_view: boolean
  can_course_registration_add: boolean
  can_course_registration_edit: boolean
  can_course_registration_delete: boolean
  can_infrastructure_view: boolean
  can_infrastructure_buildings_view: boolean
  can_infrastructure_buildings_add: boolean
  can_infrastructure_buildings_edit: boolean
  can_infrastructure_buildings_delete: boolean
  can_infrastructure_labs_view: boolean
  can_infrastructure_labs_add: boolean
  can_infrastructure_labs_edit: boolean
  can_infrastructure_labs_delete: boolean
  can_infrastructure_classrooms_view: boolean
  can_infrastructure_classrooms_add: boolean
  can_infrastructure_classrooms_edit: boolean
  can_infrastructure_classrooms_delete: boolean
  can_infrastructure_equipments_view: boolean
  can_infrastructure_equipments_add: boolean
  can_infrastructure_equipments_edit: boolean
  can_infrastructure_equipments_delete: boolean
  can_infrastructure_equipments_history_manage: boolean
  can_infrastructure_equipments_documents_manage: boolean
  can_view_mentors: boolean
  can_add_mentors: boolean
  can_assign_mentees: boolean
  can_remove_mentees: boolean
  can_view_mentor_report: boolean
  can_comment_on_mentor_report: boolean
  can_view_mentees: boolean
  can_create_session: boolean
  can_view_mentee_report: boolean
  can_view_mentor_sessions: boolean
  can_view_mentor_sessions_comments: boolean
  can_add_mentor_sessions_comments: boolean
  can_edit_mentor_sessions_comments: boolean
  can_delete_mentor_sessions_comments: boolean
  can_extra_curricular_activities_news_feed: boolean
  can_extra_curricular_activities_clubs: boolean
  can_extra_curricular_activities_events: boolean
  can_classroom_view: boolean
  can_classroom_add: boolean
  can_classroom_edit: boolean
  can_classroom_delete: boolean
  can_classroom_re_assign_faculty: boolean
  can_classroom_reports: boolean
  can_view_fee_due_report: boolean
  can_classroom_revoke_marks: boolean
  can_classroom_subjects_view: boolean
  can_classroom_subject_attendance_edit: boolean
  can_classroom_subject_assessment_create: boolean
  can_classroom_subject_assessment_delete: boolean
  can_classroom_subject_assessment_link_exam: boolean
  can_classroom_subject_session_delete: boolean
  can_classroom_session_add: boolean
  can_classroom_session_edit: boolean
  can_classroom_session_delete: boolean
  can_view_my_subjects: boolean
  can_feed_add: boolean
  can_degrees_add: boolean
  can_degrees_view: boolean
  can_degrees_edit: boolean
  can_degrees_delete: boolean
  can_programs_add: boolean
  can_programs_view: boolean
  can_programs_edit: boolean
  can_programs_delete: boolean
  can_semesters_view: boolean
  can_semesters_add: boolean
  can_semesters_edit: boolean
  can_semesters_delete: boolean
  can_notice_board_view: boolean
  can_notice_board_add: boolean
  can_notice_board_edit: boolean
  can_notice_board_delete: boolean
  can_research_project_view: boolean
  can_research_project_add: boolean
  can_research_project_edit: boolean
  can_research_project_delete: boolean
  can_configuration_view: boolean
  can_curriculums_add: boolean
  can_curriculums_view: boolean
  can_curriculums_edit: boolean
  can_curriculums_delete: boolean
  can_subject_types_view: boolean
  can_subject_types_add: boolean
  can_subject_types_edit: boolean
  can_subject_types_delete: boolean
  can_assessment_types_view: boolean
  can_assessment_types_add: boolean
  can_assessment_types_edit: boolean
  can_assessment_types_delete: boolean
  can_assessment_templates_add: boolean
  can_assessment_templates_view: boolean
  can_assessment_templates_edit: boolean
  can_assessment_templates_delete: boolean
  can_assessment_rules_view: boolean
  can_assessment_rules_add: boolean
  can_assessment_rules_edit: boolean
  can_assessment_rules_delete: boolean
  can_schools_view: boolean
  can_schools_add: boolean
  can_schools_edit: boolean
  can_schools_delete: boolean
  can_master_subject_view: boolean
  can_master_subject_add: boolean
  can_master_subject_edit: boolean
  can_master_subject_delete: boolean
  can_academic_calendar_view: boolean
  can_academic_calendar_event_add: boolean
  can_academic_calendar_event_edit: boolean
  can_academic_calendar_event_delete: boolean
  can_academic_calendar_timeline_view: boolean
  can_tasks_add: boolean
  can_tasks_edit: boolean
  can_tasks_change_status: boolean
  can_tasks_view: boolean
  can_tasks_delete: boolean
  can_time_slot_template_add: boolean
  can_time_slot_template_view: boolean
  can_time_slot_template_edit: boolean
  can_time_slot_template_delete: boolean
  can_time_slots_view: boolean
  can_time_slots_add: boolean
  can_time_slots_edit: boolean
  can_time_slots_delete: boolean
  can_departments_view: boolean
  can_departments_add: boolean
  can_departments_edit: boolean
  can_departments_delete: boolean
  can_designations_add: boolean
  can_designations_edit: boolean
  can_designations_view: boolean
  can_designations_delete: boolean
  can_form_builder_add: boolean
  can_form_builder_edit: boolean
  can_form_builder_view: boolean
  can_form_builder_delete: boolean
  can_surveys_add: boolean
  can_surveys_edit: boolean
  can_surveys_view: boolean
  can_surveys_delete: boolean
  can_view_feedbacks: boolean
  can_create_feedback: boolean
  can_manage_target_audience: boolean
  can_configure_feedback_form: boolean
  can_change_feedback_status: boolean
  can_view_feedback_questions: boolean
  can_create_feedback_question: boolean
  can_edit_feedback_question: boolean
  can_finalize_feedback_question: boolean
  can_delete_feedback_question: boolean
  can_institutions_view: boolean
  can_institutions_add: boolean
  can_institutions_edit: boolean
  can_institutions_delete: boolean
  can_institution_configuration_view: boolean
  can_institution_configuration_edit: boolean
  can_birds_eye_view: boolean
  can_manage_payments_profile_permissions_view: boolean
  can_manage_payments_profile_permissions_add: boolean
  can_manage_payments_profile_permissions_edit: boolean
  can_manage_payments_profile_permissions_delete: boolean
  can_fee_counter_academic_fee: boolean
  can_fee_counter_exam_fee: boolean
  can_payments_manage_settings: boolean
  can_payment_reports_view: boolean
  can_fee_report_view: boolean
  can_fee_due_list_view: boolean
  can_consolidated_fee_due_list_view: boolean
  can_advance_due_report_view: boolean
  can_fee_by_class_view: boolean
  can_branch_wise_report_view: boolean
  can_detained_student_view: boolean
  can_discontinued_student_view: boolean
  can_concession_report_view: boolean
  can_fee_type_summary_report_view: boolean
  can_program_wise_fee_type_report_view: boolean
  can_examination_report_view: boolean
  can_examination_not_paid_report_view: boolean
  can_examination_blocked_students_view: boolean
  can_payment_x_view_audit_logs: boolean
  can_fee_types_view: boolean
  can_fee_types_add: boolean
  can_fee_types_edit: boolean
  can_fee_types_delete: boolean
  can_fee_groups_view: boolean
  can_fee_groups_add: boolean
  can_fee_groups_edit: boolean
  can_fee_groups_delete: boolean
  can_fine_configurations_view: boolean
  can_fine_configurations_add: boolean
  can_fine_configurations_edit: boolean
  can_fine_configurations_delete: boolean
  can_student_permissions_view: boolean
  can_student_permissions_add: boolean
  can_student_permissions_edit: boolean
  can_student_permissions_delete: boolean
  can_fee_structure_view: boolean
  can_fee_structure_add: boolean
  can_fee_structure_edit: boolean
  can_fee_structure_delete: boolean
  can_concession_view: boolean
  can_concession_change_status: boolean
  can_concession_edit: boolean
  can_student_fee_card_view: boolean
  can_import_receipts_view: boolean
  can_import_credits_view: boolean
  can_transcation_card_view: boolean
  can_dashboard_view: boolean
  can_transfer_admissions: boolean
  can_restore_fee_transactions: boolean
  can_fees_import: boolean
  can_reports_view: boolean
  can_transaction_delete: boolean
  can_transaction_edit: boolean
  can_manage_enroll_x_profile_permissions_view: boolean
  can_manage_enroll_x_profile_permissions_add: boolean
  can_manage_enroll_x_profile_permissions_edit: boolean
  can_manage_enroll_x_profile_permissions_delete: boolean
  can_admissions_view: boolean
  can_admissions_add: boolean
  can_admissions_edit: boolean
  can_admissions_delete: boolean
  can_admissions_reject: boolean
  can_admissions_change_status: boolean
  can_admissions_change_quota: boolean
  can_admissions_import: boolean
  can_admissions_export: boolean
  can_admissions_confirmed_students: boolean
  can_admissions_confirm: boolean
  can_admission_graph_view: boolean
  can_admission_lead_remarks: boolean
  can_admission_approvals: boolean
  can_admission_dashboard_view: boolean
  can_admissions_view_cet: boolean
  can_admissions_edit_cet: boolean
  can_admissions_download_cet: boolean
  can_admissions_view_phd_applications: boolean
  can_admissions_download_phd_applications: boolean
  can_counsellor_view: boolean
  can_counsellor_add: boolean
  can_counsellor_delete: boolean
  can_leads_view: boolean
  can_leads_add: boolean
  can_leads_edit: boolean
  can_leads_delete: boolean
  can_leads_assign_counsellor: boolean
  can_leads_import: boolean
  can_leads_convert_to_admission: boolean
  can_clusters_view: boolean
  can_clusters_add: boolean
  can_clusters_edit: boolean
  can_clusters_delete: boolean
  can_clusters_dashboard_view: boolean
  can_notification_view: boolean
  can_notification_add: boolean
  can_notification_edit: boolean
  can_notification_delete: boolean
  can_lead_status_view: boolean
  can_lead_status_add: boolean
  can_lead_status_edit: boolean
  can_lead_status_delete: boolean
  can_lead_sources_view: boolean
  can_lead_sources_add: boolean
  can_lead_sources_edit: boolean
  can_lead_sources_delete: boolean
  can_quotas_view: boolean
  can_quotas_add: boolean
  can_quotas_edit: boolean
  can_quotas_delete: boolean
  can_counsellor_report_view: boolean
  can_caste_view: boolean
  can_caste_add: boolean
  can_caste_edit: boolean
  can_caste_delete: boolean
  can_enroll_x_view_audit_logs: boolean
  can_enroll_x_manage_settings: boolean
  can_enroll_x_concession_view: boolean
  can_enroll_x_concession_change_status: boolean
  can_student_certificates_view: boolean
  can_student_certificates_add: boolean
  can_student_certificates_edit: boolean
  can_student_certificates_delete: boolean
  can_manage_exams_profile_permissions_view: boolean
  can_manage_exams_profile_permissions_add: boolean
  can_manage_exams_profile_permissions_edit: boolean
  can_manage_exams_profile_permissions_delete: boolean
  can_end_semester_examinations_view: boolean
  can_end_semester_examinations_add: boolean
  can_end_semester_examinations_archive_exam: boolean
  can_end_semester_examinations_edit: boolean
  can_end_semester_examinations_notification_details_view: boolean
  can_exam_fee_configuration_view: boolean
  can_exam_fee_configuration_add: boolean
  can_exam_registrations_view: boolean
  can_exam_registrations_add: boolean
  can_exam_registrations_submit: boolean
  can_exam_registrations_challan_upload: boolean
  can_challan_registrations_add: boolean
  can_challan_registrations_view: boolean
  can_challan_upload_view: boolean
  can_challan_upload_add: boolean
  can_question_paper_upload_view: boolean
  can_question_paper_upload_add: boolean
  can_question_paper_upload_edit: boolean
  can_exam_timetable_view: boolean
  can_exam_timetable_add: boolean
  can_exam_timetable_edit: boolean
  can_exam_timetable_delete: boolean
  can_exam_time_slots_view: boolean
  can_exam_time_slots_add: boolean
  can_exam_time_slots_edit: boolean
  can_exam_time_slots_delete: boolean
  can_hall_tickets_view: boolean
  can_hall_tickets_download: boolean
  can_omrs_view: boolean
  can_omrs_update: boolean
  can_omrs_generate: boolean
  can_omrs_download: boolean
  can_paper_configuration_view: boolean
  can_paper_configuration_add: boolean
  can_paper_configuration_edit: boolean
  can_paper_configuration_delete: boolean
  can_paper_configuration_download: boolean
  can_d_forms_view: boolean
  can_d_forms_add: boolean
  can_d_forms_download: boolean
  can_view_answer_sheet_report: boolean
  can_bundling_view: boolean
  can_bundling_add: boolean
  can_bundling_edit: boolean
  can_bundling_delete: boolean
  can_bundling_update_bundle_status: boolean
  can_bundling_bundle_sheets_add: boolean
  can_bundling_bundle_sheets_remove: boolean
  can_internal_marks_view: boolean
  can_internal_marks_add: boolean
  can_internal_marks_edit: boolean
  can_internal_marks_import: boolean
  can_internal_marks_import_lms: boolean
  can_external_marks_view: boolean
  can_external_marks_add: boolean
  can_external_marks_edit: boolean
  can_results_processing_view_reports: boolean
  can_results_processing_moderation_and_grafting: boolean
  can_results_processing_generate_memos: boolean
  can_results_processing_publish_results: boolean
  can_revaluation_fee_configuration_view: boolean
  can_revaluation_fee_configuration_add: boolean
  can_revaluation_view: boolean
  can_revaluation_add_registrations: boolean
  can_revaluation_omrs: boolean
  can_revaluation_add_marks: boolean
  can_revaluation_edit_marks: boolean
  can_revaluation_process_reval: boolean
  can_revaluation_view_reports: boolean
  can_revaluation_generate_memos: boolean
  can_internal_examinations_view: boolean
  can_internal_examinations_add: boolean
  can_internal_examinations_edit: boolean
  can_internal_examinations_delete: boolean
  can_internal_examinations_manage_exam_fee: boolean
  can_seating_plan_view: boolean
  can_seating_plan_add: boolean
  can_seating_plan_delete: boolean
  can_invigilations_view: boolean
  can_invigilations_add: boolean
  can_evaluators_view: boolean
  can_evaluators_add: boolean
  can_evaluators_edit: boolean
  can_evaluators_delete: boolean
  can_grades_view: boolean
  can_grades_add: boolean
  can_grades_edit: boolean
  can_grades_delete: boolean
  can_exam_rooms_view: boolean
  can_exam_rooms_add: boolean
  can_exam_rooms_edit: boolean
  can_exam_rooms_delete: boolean
  can_marks_division_view: boolean
  can_marks_division_add: boolean
  can_marks_division_edit: boolean
  can_marks_division_delete: boolean
  can_exams_manage_settings: boolean
  can_internal_exam_paper_configuration_view: boolean
  can_internal_exam_paper_configuration_add: boolean
  can_internal_exam_paper_configuration_edit: boolean
  can_internal_exam_paper_configuration_delete: boolean
  can_internal_exam_timetable_view: boolean
  can_internal_exam_timetable_add: boolean
  can_internal_exam_timetable_edit: boolean
  can_internal_exam_timetable_delete: boolean
  can_exams_settings_view: boolean
  can_manage_hostels_profile_permissions_view: boolean
  can_manage_hostels_profile_permissions_add: boolean
  can_manage_hostels_profile_permissions_edit: boolean
  can_manage_hostels_profile_permissions_delete: boolean
  can_hostel_dashboard_view: boolean
  can_hostel_fee_payments_view: boolean
  can_hostel_reports_view: boolean
  can_hosteler_add: boolean
  can_hosteler_edit: boolean
  can_hosteler_view: boolean
  can_hosteler_delete: boolean
  can_hosteler_change_status: boolean
  can_hosteler_face_data_reset: boolean
  can_hosteler_consent_add: boolean
  can_hosteler_consent_edit: boolean
  can_hosteler_consent_delete: boolean
  can_hostel_fee_types_view: boolean
  can_hostel_fee_types_edit: boolean
  can_hostel_fee_types_delete: boolean
  can_hostel_fee_types_add: boolean
  can_hostel_blocks_view: boolean
  can_hostel_blocks_add: boolean
  can_hostel_blocks_edit: boolean
  can_hostel_blocks_delete: boolean
  can_hosteler_attendance_view: boolean
  can_hosteler_attendance_add: boolean
  can_hosteler_attendance_edit: boolean
  can_hostel_rooms_view: boolean
  can_hostel_rooms_edit: boolean
  can_hostel_rooms_delete: boolean
  can_hostel_rooms_add: boolean
  can_hostel_rooms_import: boolean
  can_hostel_amenities_view: boolean
  can_hostel_amenities_add: boolean
  can_hostel_amenities_edit: boolean
  can_hostel_amenities_delete: boolean
  can_hostels_manage_settings: boolean
  can_hostel_ticket_groups_view: boolean
  can_hostel_ticket_groups_add: boolean
  can_hostel_ticket_groups_edit: boolean
  can_hostel_ticket_groups_delete: boolean
  can_hostel_ticket_group_service_view: boolean
  can_hostel_ticket_group_service_add: boolean
  can_hostel_ticket_group_service_edit: boolean
  can_hostel_ticket_group_service_delete: boolean
  can_hostel_ticekt_group_users_view: boolean
  can_hostel_group_service_add: boolean
  can_hostel_group_service_delete: boolean
  can_hostel_tickets_view: boolean
  can_hostel_tickets_add: boolean
  can_hostel_tickets_edit: boolean
  can_hostel_tickets_delete: boolean
  can_manage_hrms_profile_permissions_view: boolean
  can_manage_hrms_profile_permissions_add: boolean
  can_manage_hrms_profile_permissions_edit: boolean
  can_manage_hrms_profile_permissions_delete: boolean
  can_view_information: boolean
  can_edit_information: boolean
  can_edit_special_information: boolean
  can_view_leave_tracker: boolean
  can_apply_leave: boolean
  can_view_employees: boolean
  can_edit_employees: boolean
  can_create_employees: boolean
  can_import_employees: boolean
  can_view_punch_logs: boolean
  can_view_time_sheet: boolean
  can_edit_time_sheet: boolean
  can_import_time_sheet: boolean
  can_export_time_sheet: boolean
  can_generate_time_sheet: boolean
  can_view_loss_of_pay: boolean
  can_view_leaves_usages: boolean
  can_edit_leaves_usages: boolean
  can_import_leaves_usages: boolean
  can_export_leaves_usages: boolean
  can_view_leaves_requests: boolean
  can_view_past_leaves_requests: boolean
  can_create_leaves_requests: boolean
  can_approve_leave_requests: boolean
  can_reject_leave_requests: boolean
  can_cancel_leave_requests: boolean
  can_view_departments: boolean
  can_add_departments: boolean
  can_import_departments: boolean
  can_export_departments: boolean
  can_edit_departments: boolean
  can_view_designations: boolean
  can_add_designations: boolean
  can_import_designations: boolean
  can_export_designations: boolean
  can_edit_designations: boolean
  can_view_leave_types: boolean
  can_add_leave_types: boolean
  can_edit_leave_types: boolean
  can_view_groups: boolean
  can_add_groups: boolean
  can_edit_groups_time_config: boolean
  can_edit_groups_leave_config: boolean
  can_view_database_config: boolean
  can_edit_database_config: boolean
  can_manage_commute_x_profile_permissions_view: boolean
  can_manage_commute_x_profile_permissions_add: boolean
  can_manage_commute_x_profile_permissions_edit: boolean
  can_manage_commute_x_profile_permissions_delete: boolean
  can_commute_x_registrations_view: boolean
  can_commute_x_registrations_add: boolean
  can_commute_x_registrations_edit: boolean
  can_commute_x_registrations_delete: boolean
  can_commute_x_routes_view: boolean
  can_commute_x_routes_add: boolean
  can_commute_x_routes_edit: boolean
  can_commute_x_routes_delete: boolean
  can_commute_x_manage_settings: boolean
  can_manage_admin_profile_permissions_view: boolean
  can_manage_admin_profile_permissions_add: boolean
  can_manage_admin_profile_permissions_edit: boolean
  can_manage_admin_profile_permissions_delete: boolean
  can_admin_manage_settings: boolean
  can_admin_manage_org_settings: boolean
  can_manage_user_profiles: boolean
  can_admin_institutions_view: boolean
  can_admin_institutions_add: boolean
  can_admin_institutions_edit: boolean
  can_admin_institutions_delete: boolean
  can_admin_institution_configuration_view: boolean
  can_admin_institution_configuration_edit: boolean
  can_admin_degrees_add: boolean
  can_admin_degrees_view: boolean
  can_admin_degrees_edit: boolean
  can_admin_degrees_delete: boolean
  can_admin_semesters_view: boolean
  can_admin_semesters_add: boolean
  can_admin_semesters_edit: boolean
  can_admin_semesters_delete: boolean
  can_admin_regulation_batches_view: boolean
  can_admin_regulation_batches_add: boolean
  can_admin_regulation_batches_edit: boolean
  can_admin_regulation_batches_delete: boolean
  can_admin_departments_view: boolean
  can_admin_departments_add: boolean
  can_admin_departments_edit: boolean
  can_admin_departments_delete: boolean
  can_admin_subject_types_view: boolean
  can_admin_subject_types_add: boolean
  can_admin_subject_types_edit: boolean
  can_admin_subject_types_delete: boolean
  can_admin_programs_add: boolean
  can_admin_programs_view: boolean
  can_admin_programs_edit: boolean
  can_admin_programs_delete: boolean
  can_admin_subjects_view: boolean
  can_admin_subjects_add: boolean
  can_admin_subjects_edit: boolean
  can_admin_subjects_delete: boolean
  can_admin_subjects_edit_subject_info: boolean
  can_admin_subjects_batch_config_view: boolean
  can_admin_subjects_batch_config_edit: boolean
  can_admin_students_view: boolean
  can_admin_students_add: boolean
  can_admin_students_edit: boolean
  can_admin_students_detain: boolean
  can_admin_students_import: boolean
  can_admin_students_export: boolean
  can_admin_students_results: boolean
  can_admin_students_upload_photos: boolean
  can_admin_students_transfer: boolean
  can_admin_students_allotment: boolean
  can_admin_student_info_view: boolean
  can_admin_student_academic_performance_view: boolean
  can_admin_student_attendance_view: boolean
  can_admin_student_payments_view: boolean
  can_admin_student_memos_view: boolean
  can_admin_student_backlogs_view: boolean
  can_admin_users_view: boolean
  can_admin_users_add: boolean
  can_admin_users_edit: boolean
  can_admin_users_delete: boolean
  can_admin_users_photos_upload: boolean
  can_admin_users_export: boolean
  can_admin_designations_add: boolean
  can_admin_designations_edit: boolean
  can_admin_designations_view: boolean
  can_admin_designations_delete: boolean
}

interface IPermissionsStore {
  permissions: IPermissions
  applications: string[]
  institutionType: 'MASTER_CHILD' | 'INDIVIDUAL'
  masterInstitutionUniqueId?: number
  masterInstitutionId?: string
  isMasterInstitution: boolean
  isMasterInstitutionUser?: boolean
  isHomePageEnabled?: boolean
}

export const PermissionsStore = new Store<IPermissionsStore>({
  permissions: null,
  applications: [],
  institutionType: null,
  masterInstitutionUniqueId: null,
  masterInstitutionId: null,
  isMasterInstitution: false,
  isMasterInstitutionUser: false,
  isHomePageEnabled: false,
})
